/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ActivityLog {
  /** @example "1" */
  id?: string;
  /** @example "activity_log" */
  type?: string;
  attributes?: {
    /** @example "commented" */
    action?:
      | "added"
      | "added_items_to_po"
      | "archived"
      | "calculated_fees"
      | "changed"
      | "changed_fees"
      | "changed_item_status"
      | "collected_payment"
      | "commented"
      | "completed"
      | "created"
      | "deleted"
      | "disabled"
      | "edited"
      | "editing"
      | "enabled"
      | "failed_collect_payment"
      | "finished"
      | "imported"
      | "marked_items_cant_pick"
      | "placed"
      | "paused"
      | "removed"
      | "resumed"
      | "requested"
      | "sent"
      | "sent_invoice"
      | "started"
      | "submitted"
      | "swapped_in"
      | "swapped_out"
      | "system_notification"
      | "unarchived"
      | "uploaded";
    object_text?: string | null;
    location_text?: string | null;
    field_text?: string | null;
    old_value_text?: string | null;
    new_value_text?: string | null;
    /** @example 1 */
    parent_log_id?: number | null;
    /**
     * @format datetime
     * @example "2022-05-31T19:37:19.105Z"
     */
    created_at?: string | null;
    /**
     * @format datetime
     * @example "2022-05-31T19:37:19.105Z"
     */
    updated_at?: string | null;
  };
}

export interface ActivityLogGroup {
  /** @example "1" */
  id?: string;
  /** @example "activity_log_group" */
  type?: string;
  attributes?: {
    /** @example 1 */
    loggable_id?: number;
    /** @example "User::FinalizedPurchase" */
    loggable_type?: string;
    /**
     * @format datetime
     * @example "2022-05-31T19:37:19.105Z"
     */
    created_at?: string | null;
    /**
     * @format datetime
     * @example "2022-05-31T19:37:19.105Z"
     */
    updated_at?: string | null;
  };
  relationships?: {
    user?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "user" */
        type?: string;
      };
    };
    activity_logs?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "activity_log" */
        type?: string;
      }[];
    };
  };
}

export interface Address {
  /** @example "1" */
  id?: string;
  /** @example "address" */
  type?: string;
  attributes?: {
    /** @example "118 N Peoria" */
    address1?: string;
    /** @example "3N" */
    address2?: string;
    /** @example "Chicago" */
    city?: string;
    /** @example "60607" */
    zip?: string;
  };
}

export interface AffiliateInvoice {
  /** @example "1" */
  id?: string;
  /** @example "affiliate_invoice" */
  type?: string;
  attributes?: {
    /** @example "12345" */
    invoice_number?: string | null;
    /** @example "20.99" */
    subtotal?: string | null;
    /** @example "1.99" */
    sales_tax?: string | null;
    relationships?: {
      affiliate_invoice_imports?: {
        data?: {
          /** @example "1" */
          id?: string;
          /** @example "affiliate_invoice_import" */
          type?: string;
        }[];
      };
    };
  };
}

export interface BillingProfile {
  /** @example "1" */
  id?: string;
  /** @example "billing_profile" */
  type?: string;
  attributes?: {
    /** @example "test billing_profile" */
    name?: string | null;
    /** @example "test billing_profile" */
    display_name?: string;
    /** @example 30 */
    net_terms?: number | null;
    /** @example "111111" */
    default_purchase_order?: string | null;
    /** @example "1111-1111-1111-1111" */
    credit_card_info?: string | null;
    /** @example "fa-brands fa-cc-visa" */
    credit_card_icon?: string | null;
    /** @example true */
    invoice_customer?: boolean;
    /** @example false */
    archived?: boolean;
    /** @example "test notes" */
    default_payment_notes?: string | null;
    /** @example "Monthly" */
    billing_frequency?: string | null;
    /** @example "test billing_name" */
    billing_name?: string | null;
  };
  relationships?: {
    billing_profile_budgets?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "budget" */
        type?: string;
      }[];
    };
    view_users?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "view_user" */
        type?: string;
      }[];
    };
    communication_users?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "communication_user" */
        type?: string;
      }[];
    };
  };
}

export interface Brand {
  /** @example "1" */
  id?: string;
  /** @example "brewery" */
  type?: string;
  attributes?: {
    /** @example "Andytown Coffee Roasters" */
    name?: string;
  };
  relationships?: {
    tags?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "tag" */
        type?: string;
      }[];
    };
  };
}

export interface Budget {
  /** @example "budget" */
  type?: string;
  attributes?: {
    /** @example "Block 2024 Budget" */
    name?: string | null;
    /** @example "1" */
    company_id?: string;
    /** @example "Block 2024 Budget" */
    display_name?: string;
    /** @example "2024-01-01" */
    start_date?: string | null;
    /** @example "2024-12-31" */
    end_date?: string | null;
    success_metric?: {
      /** @example "Optimize it" */
      name?: string;
      /** @example "var(--spearmint-200)" */
      color?: string;
      /** @example "var(--spearmint-1000)" */
      text_color?: string;
      /** @example "fa-regular fa-credit-card" */
      icon?: string;
      /** @example "Optimize it...?" */
      description?: string;
    };
    order_target_information?: {
      /** @example 100 */
      order_target?: number | null;
      thresholds?: object;
    };
    relationships?: {
      budget_group?: {
        data?: {
          /** @example "1" */
          id?: string;
          /** @example "budget_group" */
          type?: string;
        }[];
      };
      budgets_users?: {
        data?: {
          /** @example "1" */
          id?: string;
          /** @example "budgets_users" */
          type?: string;
        }[];
      };
    };
  };
}

export interface Building {
  /** @example "1" */
  id?: string;
  /** @example "building" */
  type?: string;
  attributes?: {
    /** @example "Creoria" */
    name?: string | nil;
  };
  relationships?: {
    address?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "address" */
        type?: string;
      };
    };
  };
}

export interface Cart {
  /** @example "1" */
  id?: string;
  attributes?: any;
}

export interface Category {
  /** @example "1" */
  id: string;
  type: "category";
  attributes?: {
    /** @example "drinks" */
    name?: string;
    /** @example "Drinks" */
    label?: string;
  };
  relationships?: {
    subcategories?: {
      data?: {
        /** @example "1" */
        id: string;
        type: "subcategory";
      }[];
    };
  };
}

export interface Comment {
  /** @example "1" */
  id?: string;
  /** @example "comment" */
  type?: string;
  attributes?: {
    /** @example true */
    edited?: boolean;
    /** @example "test comment" */
    plain_text?: string;
    /** @example "<div>test comment</div>" */
    body?: string;
    /**
     * @format datetime
     * @example "2022-06-03T16:07:00.642Z"
     */
    created_at?: string | null;
    /**
     * @format datetime
     * @example "2022-06-03T16:07:00.642Z"
     */
    updated_at?: string | null;
    relationships?: {
      user?: {
        data?: {
          /** @example "1" */
          id?: string;
          /** @example "user" */
          type?: string;
        };
      };
    };
  };
}

export interface CompaniesUser {
  /** @example "1" */
  id?: string;
  /** @example "companies_user" */
  type?: string;
  attributes?: {
    /** @example "dashboard_user" */
    relationship?: string;
    /** @example "1" */
    company_id?: number | null;
    /** @example "1" */
    corporate_user_id?: string | null;
    /** @example "1" */
    owner_id?: number | null;
    /** @example "Membership" */
    owner_type?: string | null;
    /** @example 1 */
    user_id?: number;
  };
}

export interface Company {
  /** @example "1" */
  id?: string;
  /** @example "company" */
  type?: string;
  attributes?: {
    /** @example "Crafty" */
    name?: string;
  };
}

export interface CorporateUser {
  /** @example "1" */
  id?: string;
  /** @example "corporate_user" */
  type?: string;
  attributes?: {
    /** @example "pantry" */
    program?: string;
    /** @example "drop_and_go" */
    service_type?: string | null;
    /** @example 0.1 */
    order_fee_decimal?: float | null;
    /** @example 10 */
    prepayment_percent?: number | null;
    /** @example "deliveries should be made at the back" */
    delivery_instructions?: string | null;
    /** @example "2024-04-26T03:00:00.000Z" */
    speedy_delivery_cutoff?: string | null;
    /** @example "pickups should be made at the front" */
    pickup_instructions?: string | null;
    /** @example true */
    send_missed_items?: boolean | null;
    /** @example true */
    allow_chains?: boolean;
    /** @example "inventory" */
    ic_order_method?: string | null;
    /** @example true */
    overnight?: boolean;
    /** @example "budget notes" */
    budget_notes?: string | null;
    /** @example 1 */
    default_budget_id?: number | null;
    /** @example 1 */
    suite_id?: number | null;
    /** @example "nickname" */
    nickname?: string | null;
  };
  relationships?: {
    suite?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "suite" */
        type?: string;
      };
    };
    company?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "company" */
        type?: string;
      };
    };
    companies_users?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "companies_user" */
        type?: string;
        attributes?: {
          /** @example "dashboard_user" */
          relationship?: string;
          /** @example "1" */
          company_id?: string;
          /** @example "1" */
          corporate_user_id?: string;
          /** @example "1" */
          user_id?: string;
        };
      }[];
    };
  };
}

export type CompactCollection = any;

export interface Document {
  /** @example "1" */
  id?: string;
  /** @example "document" */
  type?: string;
  attributes?: {
    /** @example "receipt.png" */
    image_file_name?: string;
    /** @example "https://happymeals.craftydelivers.com" */
    image_url?: string;
  };
}

export interface DistributionCenter {
  /** @example "1" */
  id?: string;
  /** @example "distribution_center" */
  type?: string;
  attributes?: {
    /** @example "Chicago" */
    name?: string;
    /** @example "CHI" */
    abbreviation?: string;
    /** @example false */
    all_accounts_archived?: boolean;
    distribution_type?: "direct" | "indirect";
  };
}

export interface Distributor {
  /** @example "1" */
  id?: string;
  /** @example "distributor" */
  type?: string;
  attributes?: {
    /** @example "Distributor A" */
    name?: string;
    /** @example "Distributor A - CHI" */
    name_with_abv?: string;
    /** @example false */
    partner_branch?: boolean;
  };
}

export interface ExternalUser {
  /** @example "1" */
  id?: string;
  /** @example "user" */
  type?: string;
  attributes?: {
    /** @example "crafty@example.com" */
    email?: string;
    /** @example "Crafty" */
    first_name?: string;
    /** @example "Crafty McCraftington" */
    full_name?: string;
    /** @example "McCraftington" */
    last_name?: string;
    /** @example "https://www.example.com/image" */
    profile_image?: string | null;
    /** @example "InternalUser" */
    type?: string;
    relationships?: {
      budgets_users?: {
        data?: {
          /** @example "1" */
          id?: string;
          /** @example "budgets_users" */
          type?: string;
        }[];
      };
    };
  };
}

export interface FinalizedPurchase {
  /** @example "1" */
  id?: string;
  /** @example "finalized_purchase" */
  type?: string;
  attributes?: {
    /** @example "2022-09-20" */
    delivery_date?: string;
    /** @example "2022-09-20" */
    nearest_delivery_date?: string;
    /** @example "Pizza Party" */
    order_name?: string;
    /** @example false */
    pod_submitted?: boolean;
    /** @example "2022-09-20T12:00:00Z" */
    pod_submitted_at?: string | null;
    /** @example "https://s3.us-west-2.amazonaws.com/dev.craftydelivers.com/29b2jhrqu8c9078hjf9hxmnykq2p" */
    pod_image_url?: string | null;
    /** @example [{"id":1,"url":"https://s3.us-west-2.amazonaws.com/dev.craftydelivers.com/29b2jhrqu8c9078hjf9hxmnykq2p"}] */
    pod_image_urls?: any[];
    /** @example "Delivered" */
    status_text?: string;
    /** @example "100.00" */
    total_price?: string;
    /** @example "10.00" */
    delivery_fee?: string;
    /** @example "5.00" */
    sales_tax?: string;
    /** @example "5.00" */
    service_fee?: string;
    /** @example "5.00" */
    pickup_fee?: string;
    /** @example "100.00" */
    subtotal?: string;
    /** @example "0.00" */
    applied_crafty_credit?: number | null;
    /** @example "0.00" */
    prepayment?: number | null;
    /** @example "100.00" */
    amount_paid?: string;
    /** @example "2022-09-20T12:00:00Z" */
    created_at?: string;
    /** @example "123 Main St" */
    delivery_address1?: string;
    /** @example "Suite 200" */
    delivery_address2?: string;
    /** @example "Chicago" */
    delivery_city?: string;
    /** @example "Pantry" */
    program?: string | null;
    /** @example "delivered" */
    client_order_status?: string;
    /** @example "2022-09-20T12:00:00Z" */
    client_edit_cutoff?: string | null;
    /** @example true */
    can_add_marketplace_products?: boolean;
    /** @example [{"name":"Crafty","purchasing_sizes_ids":[1,2],"delivery_date":"2022-09-20","delivery_date_end":"2022-09-20","client_order_status":"delivered","distributor_delivery_method":"stocking"}] */
    split_by_distributor?: any[];
  };
  relationships?: {
    corporate_user?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "corporate_user" */
        type?: string;
      };
    };
    pod_submitted_by?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "user" */
        type?: string;
      } | null;
    };
    budget?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "user" */
        type?: string;
      } | null;
    };
    billing_profile?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "user" */
        type?: string;
      } | null;
    };
    last_edit_log?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "activity_log" */
        type?: string;
      } | null;
    };
  };
}

export interface FinalizedPurchasesSkuImage {
  /** @example "1" */
  id?: string;
  /** @example "finalized_purchases_sku_image" */
  type?: string;
  attributes?: {
    /** @example "https://s3.us-west-2.amazonaws.com/dev.craftydelivers.com/29b2jhrqu8c9078hjf9hxmnykq2p" */
    image_url?: string;
    relationships?: {
      sku?: {
        data?: {
          /** @example "1" */
          id?: string;
          /** @example "sku" */
          type?: string;
        };
      };
      finalized_purchase?: {
        data?: {
          /** @example "1" */
          id?: string;
          /** @example "finalized_purchase" */
          type?: string;
        };
      };
    };
  };
}

export interface HubspotCompany {
  /** @example "1" */
  id?: string;
  /** @example "hubspot_company" */
  type?: string;
  attributes?: {
    /** @example "1" */
    id?: string;
    /** @example 2 */
    segment_number?: number;
  };
}

export interface Margin {
  /** @example "1" */
  id?: string | nil;
  type?: "margin";
  attributes?: {
    /** @example "1-1-1-1" */
    reference_id?: string;
    /** @example 50 */
    percentage?: number | nil;
    /** @example true */
    needs_sync?: boolean | nil;
    /** @example "subcategory_default" */
    margin_level_value?: string;
    /** @example 1 */
    subcategory_id?: number | nil;
    /** @example 1 */
    distribution_center_id?: number | nil;
    /** @example 1 */
    brand_id?: number | nil;
    /** @example 1 */
    distributor_id?: number | nil;
  };
  relationships?: {
    subcategory?: {
      data?: {
        /** @example "1" */
        id: string;
        type: "subcategory";
      };
    };
    brand?: {
      data?: {
        /** @example "1" */
        id: string;
        type: "brand";
      };
    };
    distribution_center?: {
      data?: {
        /** @example "1" */
        id: string;
        type: "distribution_center";
      };
    };
    distributor?: {
      data?: {
        /** @example "1" */
        id: string;
        type: "distributor";
      };
    };
    category?: {
      data?: {
        /** @example "1" */
        id: string;
        type: "category";
      };
    };
  };
}

export interface NavigationItem {
  id?: string;
  /** @example "navigation_item" */
  type?: string;
  attributes?: {
    /** @example "Chicago" */
    label?: string;
    /** @example "1" */
    id?: string;
    /** @example "https://www.example.com" */
    link?: string | null;
    children?: {
      /** @example "1" */
      id?: string;
      /** @example "118 N Peoria" */
      label?: string;
      /** @example "https://www.example.com" */
      link?: string | null;
      children?: {
        /** @example "1" */
        id?: string;
        /** @example "Ste. 500" */
        label?: string;
        /** @example "https://www.example.com" */
        link?: string | null;
      }[];
    }[];
  };
}

export interface OriginalPurchasingSizeGroup {
  /** @example "1" */
  id?: string;
  /** @example "original_purchasing_size_group" */
  type?: string;
  attributes?: {
    /** @example "delivered" */
    pod_status?: string;
  };
  relationships?: {
    original_purchasing_size?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "purchasing_size" */
        type?: string;
      };
    };
    chained_sku?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "purchasing_size" */
        type?: string;
      } | null;
    };
  };
}

export interface PatchBillingProfile {
  /** @example "billing_profile" */
  type?: string;
  attributes?: {
    /** @example "test billing_profile" */
    name?: string | null;
    /** @example "test billing_profile" */
    display_name?: string;
    /** @example 30 */
    net_terms?: number | null;
    /** @example "111111" */
    default_purchase_order?: string | null;
    /** @example "1111-1111-1111-1111" */
    credit_card_info?: string | null;
    /** @example "fa-brands fa-cc-visa" */
    credit_card_icon?: string | null;
    /** @example true */
    invoice_customer?: boolean;
    /** @example false */
    archived?: boolean;
    /** @example "test notes" */
    default_payment_notes?: string | null;
    /** @example "Monthly" */
    billing_frequency?: string | null;
    /** @example "test billing_name" */
    billing_name?: string | null;
    associated_budget_ids?: string[];
    address_attributes?: {
      /** @example "118 N Peoria" */
      address1?: string;
      /** @example "3N" */
      address2?: string;
      /** @example "Chicago" */
      city?: string;
      /** @example "60607" */
      zip?: string;
      /** @example "1" */
      state_id?: string;
    };
  };
}

export interface PatchCorporateUser {
  /** @example "corporate_user" */
  type?: string;
  attributes?: {
    /** @example 10 */
    prepayment_percent?: number | null;
    /** @example "deliveries should be made at the back" */
    delivery_instructions?: string | null;
    /** @example "2024-04-26T03:00:00.000Z" */
    speedy_delivery_cutoff?: string | null;
    /** @example "pickups should be made at the front" */
    pickup_instructions?: string | null;
    /** @example true */
    send_missed_items?: boolean | null;
    /** @example true */
    allow_chains?: boolean;
    /** @example "inventory" */
    ic_order_method?: string | null;
    /** @example true */
    overnight?: boolean;
    /** @example "budget notes" */
    budget_notes?: string | null;
    /** @example 1 */
    default_budget_id?: number | null;
    /** @example 1 */
    suite_id?: number | null;
    /** @example "nickname" */
    nickname?: string | null;
  };
}

export interface Photo {
  /** @example "1" */
  id?: string;
  /** @example "photo" */
  type?: string;
  attributes?: {
    /** @example "ShiftReport" */
    imageable_type?: string;
    /** @example 1 */
    imageable_id?: number;
    /**
     * @format datetime
     * @example "2000-01-01T01:00:00.000Z"
     */
    created_at?: string;
    /**
     * @format datetime
     * @example "2000-01-01T03:00:00.000Z"
     */
    updated_at?: string;
    /** @example "https://www.example.com/image.jpeg" */
    photo_url?: string;
  };
  relationships?: {
    imageable?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "shift_report" */
        type?: string;
      };
    };
  };
}

export interface Product {
  /** @example "1" */
  id?: string;
  /** @example "product" */
  type?: string;
  attributes?: {
    /** @example "Decaf Mexico Bella Vista" */
    name?: string;
  };
  relationships?: {
    brewery?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "brewery" */
        type?: string;
      };
    };
    subcategory?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "subcategory" */
        type?: string;
      };
    };
    tags?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "tag" */
        type?: string;
      }[];
    };
  };
}

export interface ProductSize {
  /** @example "1" */
  id?: string;
  /** @example "product_size" */
  type?: string;
  attributes?: {
    /** @example "5 lb bag (whole bean)" */
    name?: string;
    /** @example true */
    deliverable_item?: boolean;
  };
}

export interface PurchasingSize {
  /** @example "1" */
  id?: string;
  /** @example "purchasing_size" */
  type?: string;
  attributes?: {
    /** @example "external_id" */
    external_id?: string;
    /** @example "100.00" */
    price?: string | null;
    /** @example "1.00" */
    unit_price?: string | null;
    /** @example 10 */
    marketplace_inventory?: number | null;
  };
  relationships?: {
    original_purchasing_size_groups?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "original_purchasing_size_group" */
        type?: string;
      }[];
    };
    sku?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "sku" */
        type?: string;
      };
    };
  };
}

export interface CompactPurchasingSize {
  purchasing_sizes: {
    id: number;
    product_id: number;
    product_name: string;
    brand_name: string;
    collection_id: number;
    marketplace_inventory: number;
  }[];
}

export interface Pagination {
  meta?: {
    page?: {
      count?: number;
      items?: number;
      page?: number;
      pages?: number;
    };
  };
  links?: {
    first?: string;
    last?: string;
    prev?: string;
    next?: string;
  };
}

export interface PutSiteGuide {
  /** @example "site_guide" */
  type?: string;
  attributes?: {
    /** @example "Network name" */
    wifi_network?: string;
    /** @example "wifi_password" */
    wifi_password?: string;
    /**
     * @example "Go to 205 W. Wacker and turn to go under the bridge. Make sure to grab a
     *                       parking ticket to get validated, then take that up to the front desk."
     */
    parking_details?: string;
    /** @example true */
    badged_check_in_differs?: boolean;
    /** @example "If you are not badged, stop at front desk and talk to Gary." */
    standard_check_in_details?: string;
    /** @example "If you are badged, go through the front door and scan in." */
    badged_check_in_details?: string;
    /** @example "Storage room and walk-in keys are kept at the front desk in the third drawer. Should be in a bag together." */
    badge_and_key_storage?: string;
    /** @example "Main storage is located on the 4th floor near the primary kitchen." */
    storage_room_location?: string;
    /** @example "12" */
    contact_user_id?: string;
    /** @example "https://craftydelivers.slack.com" */
    slack_channel_link?: string;
    custom_links?: {
      /** @example "Location on Google Maps" */
      name?: string;
      /** @example "https://www.google.com/maps" */
      url?: string;
    }[];
    custom_details?: {
      /** @example "Coffee Machine Location" */
      title?: string;
      /** @example "In the hallway near the coat closet." */
      description?: string;
    }[];
  };
}

export interface Reaction {
  /** @example "😀" */
  emoji?: string;
  /** @example "grinning face" */
  emoji_alias?: string;
  /**
   * @format datetime
   * @example "2022-06-03T16:07:00.642Z"
   */
  created_at?: string | null;
  /**
   * @format datetime
   * @example "2022-06-03T16:07:00.642Z"
   */
  updated_at?: string | null;
  relationships?: {
    user?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "user" */
        type?: string;
      };
    };
    reactionable?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "activity_log" */
        type?: string;
      };
    };
  };
}

export interface RecurringOrder {
  /** @example "1" */
  id?: string;
  /** @example "recurring_order" */
  type?: string;
  attributes?: {
    /** @example true */
    safe_to_delete?: boolean;
    /** @example false */
    archived?: boolean;
    /** @example "" */
    unsafe_toggle_archive_text?: string;
    /** @example "Proposal" */
    order_status?: string;
    /** @example "EOM Order Fee" */
    name?: string;
    /** @example "Every 2 weeks" */
    schedule?: string | null;
  };
  relationships?: {
    billing_profile?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "billing_profile" */
        type?: string;
      } | null;
    };
  };
}

export interface Schedule {
  type: string;
  id: string;
  attributes: {
    events: Record<
      string,
      {
        delivery_day: boolean;
        order_ids: number[];
      }
    >;
  };
}

export interface Shift {
  /** @example "1" */
  id?: string;
  /** @example "shift" */
  type?: string;
  attributes?: {
    /** @example "Morning Shift" */
    name?: string;
  };
  relationships?: {
    corporate_user?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "corporate_user" */
        type?: string;
      };
    };
  };
}

export interface ShiftOccurrence {
  /** @example "1" */
  id?: string;
  /** @example "shift_occurrence" */
  type?: string;
  attributes?: {
    /** @example "Morning Shift" */
    name?: string;
    /** @example "2023-06-02" */
    date?: string;
    /**
     * @format datetime
     * @example "2000-01-01T01:00:00.000Z"
     */
    start_time?: string;
    /**
     * @format datetime
     * @example "2000-01-01T03:00:00.000Z"
     */
    end_time?: string;
    /** @example "Started" */
    status?: string | null;
    /** @example 1 */
    status_integer?: number | null;
    /**
     * @format datetime
     * @example "2000-01-01T01:00:00.000Z"
     */
    started_at?: string | null;
  };
  relationships?: {
    shift?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "shift" */
        type?: string;
      };
    };
  };
}

export interface ShiftReport {
  /** @example "1" */
  id?: string;
  /** @example "shift_report" */
  type?: string;
  attributes?: {
    /** @example "Shift went well!" */
    notes?: string;
    /** @example "Need more frozen pizzas" */
    other?: string;
  };
  relationships?: {
    user?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "user" */
        type?: string;
      };
    };
    shift_occurrence?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "shift_occurrence" */
        type?: string;
      };
    };
    photos?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "photos" */
        type?: string;
      }[];
    };
  };
}

export interface SiteGuide {
  /** @example "12" */
  id?: string;
  /** @example "site_guide" */
  type?: string;
  attributes?: {
    /** @example "Network name" */
    wifi_network?: string;
    /** @example "wifi_password" */
    wifi_password?: string;
    /**
     * @example "Go to 205 W. Wacker and turn to go under the bridge. Make sure to grab a
     *                       parking ticket to get validated, then take that up to the front desk."
     */
    parking_details?: string;
    /** @example true */
    badged_check_in_differs?: boolean;
    /** @example "If you are not badged, stop at front desk and talk to Gary." */
    standard_check_in_details?: string;
    /** @example "If you are badged, go through the front door and scan in." */
    badged_check_in_details?: string;
    /** @example "Storage room and walk-in keys are kept at the front desk in the third drawer. Should be in a bag together." */
    badge_and_key_storage?: string;
    /** @example "Main storage is located on the 4th floor near the primary kitchen." */
    storage_room_location?: string;
    /** @example "https://craftydelivers.slack.com" */
    slack_channel_link?: string;
    custom_links?: {
      /** @example "Location on Google Maps" */
      name?: string;
      /** @example "https://www.google.com/maps" */
      url?: string;
    }[];
    custom_details?: {
      /** @example "Coffee Machine Location" */
      title?: string;
      /** @example "In the hallway near the coat closet." */
      description?: string;
    }[];
  };
  relationships?: {
    membership?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "membership" */
        type?: string;
      };
    };
    contact_user?: {
      data?: null | {
        /** @example "1" */
        id?: string;
        /** @example "user" */
        type?: string;
      };
    };
    location_owners?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "user" */
        type?: string;
      }[];
    };
    shift_reviewers?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "user" */
        type?: string;
      }[];
    };
  };
}

export interface Sku {
  /** @example "1" */
  id?: string;
  /** @example "sku" */
  type?: string;
  attributes?: {
    /** @example "855188003004" */
    upc?: string | null;
    /** @example "unit" */
    individual_unit_measurement?: string | null;
    /** @example "https://www.example.com/image" */
    image?: string | null;
  };
  relationships?: {
    product_size?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "product_size" */
        type?: string;
      };
    };
    product?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "product" */
        type?: string;
      };
    };
    tags?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "tag" */
        type?: string;
      }[];
    };
  };
}

export type State = {
  /** @example "1" */
  id?: string;
  /** @example "state" */
  type?: string;
  attributes?: {
    /** @example "Illinois" */
    name?: string;
    /** @example "IL" */
    abbreviation?: string;
  };
  relationships?: {
    country?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "country" */
        type?: string;
      };
    };
  };
}[];

export interface Subcategory {
  /** @example "1" */
  id: string;
  type: "subcategory";
  attributes?: {
    /** @example "drinks" */
    name?: string;
    /** @example 1 */
    category_id?: number;
  };
  relationships?: {
    category?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "category" */
        type?: string;
      };
    };
  };
}

export interface Suite {
  /** @example "1" */
  id?: string;
  /** @example "suite" */
  type?: string;
  attributes?: {
    /** @example "3N" */
    name?: string;
  };
  relationships?: {
    building?: {
      data?: {
        /** @example "1" */
        id?: string;
        /** @example "building" */
        type?: string;
      };
    };
  };
}

export interface Tag {
  /** @example "1" */
  id?: string;
  /** @example "tag" */
  type?: string;
  attributes?: {
    /** @example "Organic" */
    tag?: string;
    /** @example "organic" */
    marketplace_type?: string;
    /** @example true */
    external?: boolean;
  };
}

export interface Unwrapped2024 {
  id: string;
  type: string;
  attributes: {
    total_deliveries: number;
    total_unique_ic_products: number;
    top_pantry_skus: {
      image: string;
      label: string;
      unit: string;
      value: string;
    }[];
    top_beverage_skus: {
      image: string;
      label: string;
      unit: string;
      value: string;
    }[];
    most_popular_subcategories: {
      label: string;
      value: string;
    }[];
    total_merchandising_task_shift_minutes: number;
    total_equipment_task_shift_minutes: number;
    total_storage_task_shift_minutes: number;
    assigned_memberships: {
      id: number;
      name: string;
    }[];
    assigned_team_members?: {
      id: number;
      full_name: string;
    }[];
  };
}

export interface User {
  /** @example "1" */
  id?: string;
  /** @example "user" */
  type?: string;
  attributes?: {
    /** @example "crafty@example.com" */
    email?: string;
    /** @example "Crafty" */
    first_name?: string;
    /** @example "Crafty McCraftington" */
    full_name?: string;
    /** @example "McCraftington" */
    last_name?: string;
    /** @example "https://www.example.com/image" */
    profile_image?: string | null;
    /** @example "InternalUser" */
    type?: string;
  };
}

export interface Validation {
  /** @example "validation" */
  type?: string;
  attributes?: {
    /** @example true */
    valid?: boolean;
    /** @example "12345" */
    formatted_value?: string | null;
  };
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "http://{defaultHost}",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title API V1
 * @version v1
 * @baseUrl http://{defaultHost}
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Staples, Webhooks
   * @name StaplesProcessOrderConfirmationCreate
   * @summary process order confirmation
   * @request POST:/api/staples/process_order_confirmation
   */
  staplesProcessOrderConfirmationCreate = (
    data: {
      c_xml_data?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/staples/process_order_confirmation`,
      method: "POST",
      body: data,
      ...params,
    });

  activityLogs = {
    /**
     * No description
     *
     * @tags Activity Logs
     * @name MobileV1ActivityLogsList
     * @summary list activity logs
     * @request GET:/api/mobile/v1/activity_logs
     */
    mobileV1ActivityLogsList: (
      query: {
        loggable_id: number;
        loggable_type: string;
        "actions[]"?: any[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: ActivityLogGroup[];
          included?: (ActivityLog | Comment | Reaction | User)[];
        },
        void
      >({
        path: `/api/mobile/v1/activity_logs`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Activity Logs
     * @name MobileV1ActivityLogsCreate
     * @summary create activity log
     * @request POST:/api/mobile/v1/activity_logs
     */
    mobileV1ActivityLogsCreate: (
      data: {
        /** @example 1 */
        loggable_id: number;
        /** @example "Admin::Distributor" */
        loggable_type: string;
        /** @example "submitted" */
        log_action: string;
        /** @example "Inventory Counts" */
        object_text: string;
        /** @example "Operator App" */
        location_text?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: ActivityLogGroup;
          included?: (ActivityLog | Reaction | User)[];
        },
        void
      >({
        path: `/api/mobile/v1/activity_logs`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  clientInventories = {
    /**
     * No description
     *
     * @tags Client Inventories
     * @name MobileV1ClientInventoriesLastOrderList
     * @summary last order
     * @request GET:/api/mobile/v1/client_inventories/{id}/last_order
     */
    mobileV1ClientInventoriesLastOrderList: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: FinalizedPurchase;
        },
        void
      >({
        path: `/api/mobile/v1/client_inventories/${id}/last_order`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Client Inventories
     * @name MobileV1ClientInventoriesCreateOrderCreate
     * @summary create order
     * @request POST:/api/mobile/v1/client_inventories/{id}/create_order
     */
    mobileV1ClientInventoriesCreateOrderCreate: (
      id: string,
      data: {
        /** @example "1" */
        shift_id?: string;
        /** @example "2023-04-06" */
        shift_date?: string;
        /** @example true */
        skip_duplicate_check?: boolean;
        purchasing_sizes: Record<string, string>;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: FinalizedPurchase;
          included?: (
            | Address
            | Building
            | Company
            | CorporateUser
            | Suite
            | User
          )[];
        },
        void
      >({
        path: `/api/mobile/v1/client_inventories/${id}/create_order`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Client Inventories
     * @name MobileV1ClientInventoriesActivateCreate
     * @summary activates a client inventory
     * @request POST:/api/mobile/v1/client_inventories/{id}/activate
     */
    mobileV1ClientInventoriesActivateCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/mobile/v1/client_inventories/${id}/activate`,
        method: "POST",
        ...params,
      }),
  };
  comments = {
    /**
     * No description
     *
     * @tags Comments
     * @name MobileV1CommentsCreate
     * @summary Create a comment
     * @request POST:/api/mobile/v1/comments
     */
    mobileV1CommentsCreate: (
      data: {
        /** @example 1 */
        loggable_id: number;
        /** @example "User::FinalizedPurchase" */
        loggable_type: string;
        /** @example "<div>This is a comment</div>" */
        comment_body?: string;
        /** @example 1 */
        parent_log_id?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Comment;
          included?: (ActivityLog | ActivityLogGroup | User)[];
        },
        void
      >({
        path: `/api/mobile/v1/comments`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Comments
     * @name MobileV1CommentsUpdate
     * @summary Update a comment
     * @request PUT:/api/mobile/v1/comments/{id}
     */
    mobileV1CommentsUpdate: (
      id: string,
      data: {
        /** @example "<div>This is a comment</div>" */
        comment_body: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Comment;
          included?: (ActivityLog | ActivityLogGroup | User)[];
        },
        void
      >({
        path: `/api/mobile/v1/comments/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  corporateUsers = {
    /**
     * No description
     *
     * @tags Corporate Users
     * @name MobileV1CorporateUsersSiteGuideList
     * @summary get site guide for a location
     * @request GET:/api/mobile/v1/corporate_users/{id}/site_guide
     */
    mobileV1CorporateUsersSiteGuideList: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: SiteGuide;
        },
        void
      >({
        path: `/api/mobile/v1/corporate_users/${id}/site_guide`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users
     * @name MobileV1CorporateUsersDetail
     * @summary get a corporate user
     * @request GET:/api/mobile/v1/corporate_users/{id}
     */
    mobileV1CorporateUsersDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          data?: SiteGuide;
        },
        void
      >({
        path: `/api/mobile/v1/corporate_users/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Budgets, Corporate Users
     * @name MobileV1CorporateUsersOrderTargetList
     * @summary order target for a client's budget
     * @request GET:/api/mobile/v1/corporate_users/{id}/order_target
     */
    mobileV1CorporateUsersOrderTargetList: (
      id: number,
      query?: {
        target_delivery_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/mobile/v1/corporate_users/${id}/order_target`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users
     * @name MobileV1CorporateUsersProjectedOrderFeesList
     * @summary get estimated fees based on a target delivery date
     * @request GET:/api/mobile/v1/corporate_users/{id}/projected_order_fees
     */
    mobileV1CorporateUsersProjectedOrderFeesList: (
      id: number,
      query?: {
        target_delivery_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/mobile/v1/corporate_users/${id}/projected_order_fees`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersRelationshipsPartnerNavigationItemsList
     * @summary get locations associated with a partner and a corporate user
     * @request GET:/api/web/v1/corporate_users/{corporate_user_id}/relationships/partner_navigation_items
     */
    webV1CorporateUsersRelationshipsPartnerNavigationItemsList: (
      corporateUserId: number,
      query: {
        branch_id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: NavigationItem[];
        },
        void
      >({
        path: `/api/web/v1/corporate_users/${corporateUserId}/relationships/partner_navigation_items`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersPartialUpdate
     * @summary update corporate user attributes
     * @request PATCH:/api/web/v1/corporate_users/{corporate_user_id}
     */
    webV1CorporateUsersPartialUpdate: (
      corporateUserId: number,
      data: {
        data?: PatchCorporateUser;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: CorporateUser;
        },
        void
      >({
        path: `/api/web/v1/corporate_users/${corporateUserId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersDetail
     * @summary corporate user
     * @request GET:/api/web/v1/corporate_users/{corporate_user_id}
     */
    webV1CorporateUsersDetail: (
      corporateUserId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: CorporateUser;
        },
        void
      >({
        path: `/api/web/v1/corporate_users/${corporateUserId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Transactions, Web
     * @name WebV1CorporateUsersRelationshipsTransactionsList
     * @summary get transactions associated with a corporate user
     * @request GET:/api/web/v1/corporate_users/{corporate_user_id}/relationships/transactions
     */
    webV1CorporateUsersRelationshipsTransactionsList: (
      corporateUserId: number,
      query?: {
        transaction_type?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "transaction" */
            type?: string;
            attributes?: {
              /** @example "crafty_credit" */
              transaction_type?: string;
              /** @example 100.5 */
              amount?: float;
              /** @example "Granted a signing credit as a new client!" */
              reason_details?: string;
              /** @example 123 */
              finalized_purchase_id?: number | null;
              /** @example "John Smith" */
              last_updated_by?: string;
              reason?: {
                /** @example "signing_credit" */
                id?: string;
                /** @example "Signing Credit" */
                label?: string;
              };
              /** @example "01/01/21" */
              updated_date?: string;
              /** @example "Fun Order: 123" */
              order_name?: string | null;
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/corporate_users/${corporateUserId}/relationships/transactions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Transactions, Web
     * @name WebV1CorporateUsersRelationshipsTransactionsCreate
     * @summary create transaction
     * @request POST:/api/web/v1/corporate_users/{corporate_user_id}/relationships/transactions
     */
    webV1CorporateUsersRelationshipsTransactionsCreate: (
      corporateUserId: number,
      data: {
        data?: {
          /** @example "transaction" */
          type?: string;
          attributes?: {
            /** @example 100 */
            amount?: number;
            /** @example "1" */
            corporate_user_id?: string;
            /** @example "reason" */
            reason?: string;
            /** @example "reason details" */
            reason_details?: string;
            /** @example "crafty_credit" */
            transaction_type?: string;
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "transaction" */
            type?: string;
            attributes?: {
              /** @example "crafty_credit" */
              transaction_type?: string;
              /** @example 100.5 */
              amount?: float;
              /** @example "Granted a signing credit as a new client!" */
              reason_details?: string;
              /** @example 123 */
              finalized_purchase_id?: number | null;
              /** @example "John Smith" */
              last_updated_by?: string;
              reason?: {
                /** @example "signing_credit" */
                id?: string;
                /** @example "Signing Credit" */
                label?: string;
              };
              /** @example "01/01/21" */
              updated_date?: string;
              /** @example "Fun Order: 123" */
              order_name?: string | null;
            };
          };
        },
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "transaction" */
            type?: string;
            attributes?: {
              /** @example "crafty_credit" */
              transaction_type?: string;
              /** @example 100.5 */
              amount?: float;
              /** @example "Granted a signing credit as a new client!" */
              reason_details?: string;
              /** @example 123 */
              finalized_purchase_id?: number | null;
              /** @example "John Smith" */
              last_updated_by?: string;
              reason?: {
                /** @example "signing_credit" */
                id?: string;
                /** @example "Signing Credit" */
                label?: string;
              };
              /** @example "01/01/21" */
              updated_date?: string;
              /** @example "Fun Order: 123" */
              order_name?: string | null;
            };
          };
        } | void
      >({
        path: `/api/web/v1/corporate_users/${corporateUserId}/relationships/transactions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersRelationshipsBillingProfilesList
     * @summary get billing profiles associated with a corporate user
     * @request GET:/api/web/v1/corporate_users/{corporate_user_id}/relationships/billing_profiles
     */
    webV1CorporateUsersRelationshipsBillingProfilesList: (
      corporateUserId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "billing_profile" */
            type?: string;
            attributes?: {
              /** @example "test billing_profile" */
              name?: string | null;
              /** @example "test billing_profile" */
              display_name?: string;
              /** @example 30 */
              net_terms?: number | null;
              /** @example "111111" */
              default_purchase_order?: string | null;
              /** @example "1111-1111-1111-1111" */
              credit_card_info?: string | null;
              /** @example "fa-brands fa-cc-visa" */
              credit_card_icon?: string | null;
              /** @example true */
              invoice_customer?: boolean;
              /** @example false */
              archived?: boolean;
              /** @example "test notes" */
              default_payment_notes?: string | null;
              /** @example "Monthly" */
              billing_frequency?: string | null;
              /** @example "test billing_name" */
              billing_name?: string | null;
            };
            relationships?: {
              billing_profile_budgets?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "budget" */
                  type?: string;
                }[];
              };
              view_users?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "view_user" */
                  type?: string;
                }[];
              };
              communication_users?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "communication_user" */
                  type?: string;
                }[];
              };
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/corporate_users/${corporateUserId}/relationships/billing_profiles`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersRelationshipsAvailableBillingProfilesList
     * @summary get billing profiles associated with a corporate user
     * @request GET:/api/web/v1/corporate_users/{corporate_user_id}/relationships/available_billing_profiles
     */
    webV1CorporateUsersRelationshipsAvailableBillingProfilesList: (
      corporateUserId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "billing_profile" */
            type?: string;
            attributes?: {
              /** @example "test billing_profile" */
              name?: string | null;
              /** @example "test billing_profile" */
              display_name?: string;
              /** @example 30 */
              net_terms?: number | null;
              /** @example "111111" */
              default_purchase_order?: string | null;
              /** @example "1111-1111-1111-1111" */
              credit_card_info?: string | null;
              /** @example "fa-brands fa-cc-visa" */
              credit_card_icon?: string | null;
              /** @example true */
              invoice_customer?: boolean;
              /** @example false */
              archived?: boolean;
              /** @example "test notes" */
              default_payment_notes?: string | null;
              /** @example "Monthly" */
              billing_frequency?: string | null;
              /** @example "test billing_name" */
              billing_name?: string | null;
            };
            relationships?: {
              billing_profile_budgets?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "budget" */
                  type?: string;
                }[];
              };
              view_users?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "view_user" */
                  type?: string;
                }[];
              };
              communication_users?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "communication_user" */
                  type?: string;
                }[];
              };
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/corporate_users/${corporateUserId}/relationships/available_billing_profiles`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersRelationshipsAssignPrimaryBillingProfilePartialUpdate
     * @summary assign primary billing profile to a corporate user
     * @request PATCH:/api/web/v1/corporate_users/{corporate_user_id}/relationships/assign_primary_billing_profile
     */
    webV1CorporateUsersRelationshipsAssignPrimaryBillingProfilePartialUpdate: (
      corporateUserId: number,
      data: {
        data?: {
          /** @example "1" */
          billing_profile_id?: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/corporate_users/${corporateUserId}/relationships/assign_primary_billing_profile`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersRelationshipsAddBillingProfileUpdate
     * @summary add billing profile to a corporate user
     * @request PUT:/api/web/v1/corporate_users/{corporate_user_id}/relationships/add_billing_profile
     */
    webV1CorporateUsersRelationshipsAddBillingProfileUpdate: (
      corporateUserId: number,
      data: {
        data?: {
          /** @example "1" */
          billing_profile_id?: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/corporate_users/${corporateUserId}/relationships/add_billing_profile`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersRelationshipsRemoveBillingProfilePartialUpdate
     * @summary remove billing profile from a corporate user
     * @request PATCH:/api/web/v1/corporate_users/{corporate_user_id}/relationships/remove_billing_profile
     */
    webV1CorporateUsersRelationshipsRemoveBillingProfilePartialUpdate: (
      corporateUserId: number,
      data: {
        data?: {
          /** @example "1" */
          billing_profile_id?: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/corporate_users/${corporateUserId}/relationships/remove_billing_profile`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersRelationshipsOrdersList
     * @summary get paginated orders associated with a corporate user
     * @request GET:/api/web/v1/corporate_users/{corporate_user_id}/relationships/orders
     */
    webV1CorporateUsersRelationshipsOrdersList: (
      corporateUserId: number,
      query?: {
        "page[page]"?: number;
        "page[items]"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: FinalizedPurchase[];
        },
        void
      >({
        path: `/api/web/v1/corporate_users/${corporateUserId}/relationships/orders`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersRelationshipsRecurringOrdersList
     * @summary get recurring orders associated with a corporate user
     * @request GET:/api/web/v1/corporate_users/{corporate_user_id}/relationships/recurring_orders
     */
    webV1CorporateUsersRelationshipsRecurringOrdersList: (
      corporateUserId: number,
      query?: {
        /** @example "false" */
        "filter[archived]"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: RecurringOrder[];
        },
        void
      >({
        path: `/api/web/v1/corporate_users/${corporateUserId}/relationships/recurring_orders`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersArchiveCreate
     * @summary archive corporate user
     * @request POST:/api/web/v1/corporate_users/{corporate_user_id}/archive
     */
    webV1CorporateUsersArchiveCreate: (
      corporateUserId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/corporate_users/${corporateUserId}/archive`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersUnarchiveCreate
     * @summary unarchive corporate user
     * @request POST:/api/web/v1/corporate_users/{corporate_user_id}/unarchive
     */
    webV1CorporateUsersUnarchiveCreate: (
      corporateUserId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/corporate_users/${corporateUserId}/unarchive`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Corporate Users, Web
     * @name WebV1CorporateUsersDeleteCreate
     * @summary delete transaction
     * @request POST:/api/web/v1/corporate_users/{corporate_user_id}/delete
     */
    webV1CorporateUsersDeleteCreate: (
      corporateUserId: number,
      data: {
        /** @example "1" */
        replacement_account_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/corporate_users/${corporateUserId}/delete`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  feedback = {
    /**
     * No description
     *
     * @tags Feedback
     * @name MobileV1FeedbackSendEmailCreate
     * @summary send feedback email
     * @request POST:/api/mobile/v1/feedback/send_email
     */
    mobileV1FeedbackSendEmailCreate: (
      data: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/mobile/v1/feedback/send_email`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  };
  finalizedPurchasesSkuImages = {
    /**
     * No description
     *
     * @tags Order SKU Images
     * @name MobileV1FinalizedPurchasesSkuImagesDelete
     * @summary deletes a finalized purchase sku image
     * @request DELETE:/api/mobile/v1/finalized_purchases_sku_images/{id}
     */
    mobileV1FinalizedPurchasesSkuImagesDelete: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/mobile/v1/finalized_purchases_sku_images/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order SKU Images
     * @name MobileV1FinalizedPurchasesSkuImagesCreate
     * @summary creates a finalized purchase sku image
     * @request POST:/api/mobile/v1/finalized_purchases_sku_images
     */
    mobileV1FinalizedPurchasesSkuImagesCreate: (
      data: File,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: FinalizedPurchasesSkuImage;
        },
        void
      >({
        path: `/api/mobile/v1/finalized_purchases_sku_images`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  orders = {
    /**
     * No description
     *
     * @tags Orders
     * @name MobileV1OrdersList
     * @summary list orders
     * @request GET:/api/mobile/v1/orders
     */
    mobileV1OrdersList: (
      query?: {
        "filter[delivery_date]"?: string;
        "filter[deliverable]"?: string;
        "filter[corporate_user_id]"?: string;
        "filter[pod_submitted]"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: FinalizedPurchase[];
          included?: (
            | Address
            | Building
            | Company
            | CorporateUser
            | Suite
            | User
          )[];
        },
        void
      >({
        path: `/api/mobile/v1/orders`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name MobileV1OrdersFinalizePodUpdate
     * @summary finalize pod
     * @request PUT:/api/mobile/v1/orders/{id}/finalize_pod
     */
    mobileV1OrdersFinalizePodUpdate: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: FinalizedPurchase;
          included?: (
            | Address
            | Building
            | Company
            | CorporateUser
            | Suite
            | User
          )[];
        },
        void
      >({
        path: `/api/mobile/v1/orders/${id}/finalize_pod`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name MobileV1OrdersPartialUpdate
     * @summary update order
     * @request PATCH:/api/mobile/v1/orders/{id}
     */
    mobileV1OrdersPartialUpdate: (
      id: string,
      data: File,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: FinalizedPurchase;
          included?: (
            | Address
            | Building
            | Company
            | CorporateUser
            | Suite
            | User
          )[];
        },
        void
      >({
        path: `/api/mobile/v1/orders/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name MobileV1OrdersPodImageCreate
     * @summary add pod image to order
     * @request POST:/api/mobile/v1/orders/{id}/pod_image
     */
    mobileV1OrdersPodImageCreate: (
      id: string,
      data: File,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: FinalizedPurchase;
          included?: (
            | Address
            | Building
            | Company
            | CorporateUser
            | Suite
            | User
          )[];
        },
        void
      >({
        path: `/api/mobile/v1/orders/${id}/pod_image`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name MobileV1OrdersPodImageDelete
     * @summary delete pod image
     * @request DELETE:/api/mobile/v1/orders/{id}/pod_image/{image_id}
     */
    mobileV1OrdersPodImageDelete: (
      id: string,
      imageId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: FinalizedPurchase;
          included?: (
            | Address
            | Building
            | Company
            | CorporateUser
            | Suite
            | User
          )[];
        },
        void
      >({
        path: `/api/mobile/v1/orders/${id}/pod_image/${imageId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  originalPurchasingSizeGroups = {
    /**
     * No description
     *
     * @tags OPSGs
     * @name MobileV1OriginalPurchasingSizeGroupsList
     * @summary list original purchasing size groups
     * @request GET:/api/mobile/v1/original_purchasing_size_groups
     */
    mobileV1OriginalPurchasingSizeGroupsList: (
      query: {
        finalized_purchase_id: string;
        "filter[deliverable]"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: OriginalPurchasingSizeGroup[];
          included?: (
            | Brand
            | Product
            | ProductSize
            | PurchasingSize
            | Sku
            | Subcategory
          )[];
        },
        void
      >({
        path: `/api/mobile/v1/original_purchasing_size_groups`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OPSGs
     * @name MobileV1OriginalPurchasingSizeGroupsUpdateForPodUpdate
     * @summary update multiple original purchasing size groups pod status
     * @request PUT:/api/mobile/v1/original_purchasing_size_groups/update_for_pod
     */
    mobileV1OriginalPurchasingSizeGroupsUpdateForPodUpdate: (
      data: {
        /** @example 1 */
        finalized_purchase_id: number;
        original_purchasing_size_groups: {
          "1"?: {
            /** @example "delivered" */
            pod_status?: string;
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: OriginalPurchasingSizeGroup[];
        },
        void
      >({
        path: `/api/mobile/v1/original_purchasing_size_groups/update_for_pod`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OPSGs
     * @name MobileV1OriginalPurchasingSizeGroupsAddToPodCreate
     * @summary add skus to a pod
     * @request POST:/api/mobile/v1/original_purchasing_size_groups/add_to_pod
     */
    mobileV1OriginalPurchasingSizeGroupsAddToPodCreate: (
      data: {
        /** @example 1 */
        finalized_purchase_id: number;
        skus: {
          "1"?: {
            /** @example "delivered" */
            pod_status?: string;
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          errors?: {
            /** @example "1" */
            sku_id?: number;
            /** @example "No Distributor Product" */
            title?: string;
            /** @example "No distributor product found for this SKU" */
            detail?: string;
          }[];
        },
        void
      >({
        path: `/api/mobile/v1/original_purchasing_size_groups/add_to_pod`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  photos = {
    /**
     * No description
     *
     * @tags Photos
     * @name MobileV1PhotosCreate
     * @summary creates a photo
     * @request POST:/api/mobile/v1/photos
     */
    mobileV1PhotosCreate: (data: File, params: RequestParams = {}) =>
      this.request<
        {
          data?: Photo;
          included?: ShiftReport[];
        },
        void
      >({
        path: `/api/mobile/v1/photos`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  reactions = {
    /**
     * No description
     *
     * @tags Reactions
     * @name MobileV1ReactionsDelete
     * @summary deletes a reaction
     * @request DELETE:/api/mobile/v1/reactions/{id}
     */
    mobileV1ReactionsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/mobile/v1/reactions/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reactions
     * @name MobileV1ReactionsCreate
     * @summary creates a reaction
     * @request POST:/api/mobile/v1/reactions
     */
    mobileV1ReactionsCreate: (
      data: {
        /** @example 1 */
        reactionable_id: number;
        /** @example "ActivityLog" */
        reactionable_type: string;
        /** @example "😀" */
        emoji: string;
        /** @example "grinning face" */
        emoji_alias: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Reaction;
          included?: ActivityLog[];
        },
        void
      >({
        path: `/api/mobile/v1/reactions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shiftReports = {
    /**
     * No description
     *
     * @tags Shift Reports
     * @name MobileV1ShiftReportsList
     * @summary list shift reports
     * @request GET:/api/mobile/v1/shift_reports
     */
    mobileV1ShiftReportsList: (params: RequestParams = {}) =>
      this.request<
        {
          data?: ShiftReport[];
          included?: (Shift | ShiftOccurrence | CorporateUser)[];
        },
        void
      >({
        path: `/api/mobile/v1/shift_reports`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift Reports
     * @name MobileV1ShiftReportsCreate
     * @summary creates shift report
     * @request POST:/api/mobile/v1/shift_reports
     */
    mobileV1ShiftReportsCreate: (
      data: {
        /** @example "Here are some notes" */
        notes: string;
        /** @example "Here are some other details about the shift" */
        other: string;
        /** @example 1 */
        shift_occurrence_id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: ShiftReport;
          included?: ShiftOccurrence[];
        },
        void
      >({
        path: `/api/mobile/v1/shift_reports`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift Reports
     * @name MobileV1ShiftReportsDetail
     * @summary get shift report
     * @request GET:/api/mobile/v1/shift_reports/{id}
     */
    mobileV1ShiftReportsDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: ShiftReport;
          included?: Photo[];
        },
        void
      >({
        path: `/api/mobile/v1/shift_reports/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  shifts = {
    /**
     * No description
     *
     * @tags Shifts
     * @name MobileV1ShiftsDateUpdateStatusUpdate
     * @summary update shift status
     * @request PUT:/api/mobile/v1/shifts/{id}/date/{date}/update_status
     */
    mobileV1ShiftsDateUpdateStatusUpdate: (
      id: string,
      date: string,
      data: {
        /** @example 1 */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: ShiftOccurrence;
        },
        void
      >({
        path: `/api/mobile/v1/shifts/${id}/date/${date}/update_status`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  skus = {
    /**
     * No description
     *
     * @tags SKUs
     * @name MobileV1SkusList
     * @summary list skus
     * @request GET:/api/mobile/v1/skus
     */
    mobileV1SkusList: (
      query?: {
        "filter[corporate_user_id]"?: string;
        "filter[deliverable]"?: string;
        "filter[text_search]"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Sku[];
          included?: (Brand | Product | ProductSize | Subcategory)[];
        },
        void
      >({
        path: `/api/mobile/v1/skus`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags Users
     * @name MobileV1UsersList
     * @summary list users
     * @request GET:/api/mobile/v1/users
     */
    mobileV1UsersList: (
      query?: {
        "advanced_filters[loggable_id]"?: number;
        "advanced_filters[loggable_type]"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: User[];
        },
        void
      >({
        path: `/api/mobile/v1/users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name MobileV1UsersPartialUpdate
     * @summary update user
     * @request PATCH:/api/mobile/v1/users/{id}
     */
    mobileV1UsersPartialUpdate: (
      id: string,
      data: {
        /** @format binary */
        avatar: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: User;
        },
        void
      >({
        path: `/api/mobile/v1/users/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name MobileV1UsersDetail
     * @summary Retrieve a user
     * @request GET:/api/mobile/v1/users/{id}
     */
    mobileV1UsersDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          data?: User;
        },
        void
      >({
        path: `/api/mobile/v1/users/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name MobileV1UsersDeleteAvatarDelete
     * @summary delete avatar
     * @request DELETE:/api/mobile/v1/users/{id}/delete_avatar
     */
    mobileV1UsersDeleteAvatarDelete: (id: string, params: RequestParams = {}) =>
      this.request<
        void,
        void | {
          error?: string;
        }
      >({
        path: `/api/mobile/v1/users/${id}/delete_avatar`,
        method: "DELETE",
        ...params,
      }),
  };
  affiliateInvoices = {
    /**
     * No description
     *
     * @tags Affiliate Invoices, Web
     * @name WebV1AffiliateInvoicesDetail
     * @summary get affiliate invoice
     * @request GET:/api/web/v1/affiliate_invoices/{affiliate_invoice_id}
     */
    webV1AffiliateInvoicesDetail: (
      affiliateInvoiceId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "1" */
          id?: string;
          /** @example "affiliate_invoice" */
          type?: string;
          attributes?: {
            /** @example "12345" */
            invoice_number?: string | null;
            /** @example "20.99" */
            subtotal?: string | null;
            /** @example "1.99" */
            sales_tax?: string | null;
            relationships?: {
              affiliate_invoice_imports?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "affiliate_invoice_import" */
                  type?: string;
                }[];
              };
            };
          };
        },
        void
      >({
        path: `/api/web/v1/affiliate_invoices/${affiliateInvoiceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate Invoices, Web
     * @name WebV1AffiliateInvoicesRelationshipsAffiliateInvoiceImportsBulkArchiveCreate
     * @summary archives affiliate invoice imports associated with the affiliate invoice
     * @request POST:/api/web/v1/affiliate_invoices/{affiliate_invoice_id}/relationships/affiliate_invoice_imports/bulk_archive
     */
    webV1AffiliateInvoicesRelationshipsAffiliateInvoiceImportsBulkArchiveCreate:
      (
        affiliateInvoiceId: number,
        data: {
          data?: {
            /** @example "affiliate_invoice_import" */
            type?: string;
            /** @example "1" */
            id?: string;
          }[];
        },
        params: RequestParams = {},
      ) =>
        this.request<string, void>({
          path: `/api/web/v1/affiliate_invoices/${affiliateInvoiceId}/relationships/affiliate_invoice_imports/bulk_archive`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),
  };
  billingProfiles = {
    /**
     * No description
     *
     * @tags Billing Profiles, Web
     * @name WebV1BillingProfilesDetail
     * @summary get billing profile info
     * @request GET:/api/web/v1/billing_profiles/{billing_profile_id}
     */
    webV1BillingProfilesDetail: (
      billingProfileId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: BillingProfile;
        },
        void
      >({
        path: `/api/web/v1/billing_profiles/${billingProfileId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing Profiles, Web
     * @name WebV1BillingProfilesPartialUpdate
     * @summary update billing profile info
     * @request PATCH:/api/web/v1/billing_profiles/{billing_profile_id}
     */
    webV1BillingProfilesPartialUpdate: (
      billingProfileId: number,
      data: {
        data?: PatchBillingProfile;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: BillingProfile;
        },
        void
      >({
        path: `/api/web/v1/billing_profiles/${billingProfileId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  breweries = {
    /**
     * No description
     *
     * @tags Breweries, Web
     * @name WebV1BreweriesList
     * @summary get list of breweries
     * @request GET:/api/web/v1/breweries
     */
    webV1BreweriesList: (
      query?: {
        search?: string;
        "distributor_ids[]"?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "brewery" */
            type?: string;
            attributes?: {
              /** @example "Andytown Coffee Roasters" */
              name?: string;
            };
            relationships?: {
              tags?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "tag" */
                  type?: string;
                }[];
              };
            };
          }[];
          meta?: {
            page?: {
              count?: number;
              items?: number;
              page?: number;
              pages?: number;
            };
          };
          links?: {
            first?: string;
            last?: string;
            prev?: string;
            next?: string;
          };
        },
        void
      >({
        path: `/api/web/v1/breweries`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  budgets = {
    /**
     * No description
     *
     * @tags Budgets, Web
     * @name WebV1BudgetsRelationshipsBudgetUsersList
     * @summary get external users assigned to a budget
     * @request GET:/api/web/v1/budgets/{budget_id}/relationships/budget_users
     */
    webV1BudgetsRelationshipsBudgetUsersList: (
      budgetId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: ExternalUser[];
        },
        void
      >({
        path: `/api/web/v1/budgets/${budgetId}/relationships/budget_users`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Budgets, Web
     * @name WebV1BudgetsDetail
     * @summary get budget
     * @request GET:/api/web/v1/budgets/{budget_id}
     */
    webV1BudgetsDetail: (budgetId: number, params: RequestParams = {}) =>
      this.request<
        {
          data?: {
            /** @example "budget" */
            type?: string;
            attributes?: {
              /** @example "Block 2024 Budget" */
              name?: string | null;
              /** @example "1" */
              company_id?: string;
              /** @example "Block 2024 Budget" */
              display_name?: string;
              /** @example "2024-01-01" */
              start_date?: string | null;
              /** @example "2024-12-31" */
              end_date?: string | null;
              success_metric?: {
                /** @example "Optimize it" */
                name?: string;
                /** @example "var(--spearmint-200)" */
                color?: string;
                /** @example "var(--spearmint-1000)" */
                text_color?: string;
                /** @example "fa-regular fa-credit-card" */
                icon?: string;
                /** @example "Optimize it...?" */
                description?: string;
              };
              order_target_information?: {
                /** @example 100 */
                order_target?: number | null;
                thresholds?: object;
              };
              relationships?: {
                budget_group?: {
                  data?: {
                    /** @example "1" */
                    id?: string;
                    /** @example "budget_group" */
                    type?: string;
                  }[];
                };
                budgets_users?: {
                  data?: {
                    /** @example "1" */
                    id?: string;
                    /** @example "budgets_users" */
                    type?: string;
                  }[];
                };
              };
            };
          };
        },
        void
      >({
        path: `/api/web/v1/budgets/${budgetId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Budgets, Web
     * @name WebV1BudgetsOrderAverageList
     * @summary get order averages for a budget
     * @request GET:/api/web/v1/budgets/{budget_id}/order_average
     */
    webV1BudgetsOrderAverageList: (
      budgetId: number,
      query?: {
        /** @example ["1","2","3"] */
        "filter[accounts]"?: any[];
        /** @example "12" */
        "filter[month]"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "budget" */
            type?: string;
            attributes?: {
              /** @example "Block 2024 Budget" */
              name?: string | null;
              /** @example "1" */
              company_id?: string;
              /** @example "Block 2024 Budget" */
              display_name?: string;
              /** @example "2024-01-01" */
              start_date?: string | null;
              /** @example "2024-12-31" */
              end_date?: string | null;
              success_metric?: {
                /** @example "Optimize it" */
                name?: string;
                /** @example "var(--spearmint-200)" */
                color?: string;
                /** @example "var(--spearmint-1000)" */
                text_color?: string;
                /** @example "fa-regular fa-credit-card" */
                icon?: string;
                /** @example "Optimize it...?" */
                description?: string;
              };
              order_target_information?: {
                /** @example 100 */
                order_target?: number | null;
                thresholds?: object;
              };
              relationships?: {
                budget_group?: {
                  data?: {
                    /** @example "1" */
                    id?: string;
                    /** @example "budget_group" */
                    type?: string;
                  }[];
                };
                budgets_users?: {
                  data?: {
                    /** @example "1" */
                    id?: string;
                    /** @example "budgets_users" */
                    type?: string;
                  }[];
                };
              };
            };
          };
        },
        void
      >({
        path: `/api/web/v1/budgets/${budgetId}/order_average`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Budgets, Web
     * @name WebV1BudgetsServiceList
     * @summary get service days and schedule for a budget
     * @request GET:/api/web/v1/budgets/{budget_id}/service
     */
    webV1BudgetsServiceList: (budgetId: number, params: RequestParams = {}) =>
      this.request<
        {
          data?: {
            /** @example "budget" */
            type?: string;
            attributes?: {
              /** @example "Block 2024 Budget" */
              name?: string | null;
              /** @example "1" */
              company_id?: string;
              /** @example "Block 2024 Budget" */
              display_name?: string;
              /** @example "2024-01-01" */
              start_date?: string | null;
              /** @example "2024-12-31" */
              end_date?: string | null;
              success_metric?: {
                /** @example "Optimize it" */
                name?: string;
                /** @example "var(--spearmint-200)" */
                color?: string;
                /** @example "var(--spearmint-1000)" */
                text_color?: string;
                /** @example "fa-regular fa-credit-card" */
                icon?: string;
                /** @example "Optimize it...?" */
                description?: string;
              };
              order_target_information?: {
                /** @example 100 */
                order_target?: number | null;
                thresholds?: object;
              };
              relationships?: {
                budget_group?: {
                  data?: {
                    /** @example "1" */
                    id?: string;
                    /** @example "budget_group" */
                    type?: string;
                  }[];
                };
                budgets_users?: {
                  data?: {
                    /** @example "1" */
                    id?: string;
                    /** @example "budgets_users" */
                    type?: string;
                  }[];
                };
              };
            };
          };
        },
        void
      >({
        path: `/api/web/v1/budgets/${budgetId}/service`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Budgets, Web
     * @name WebV1BudgetsHubspotBudgetsCreate
     * @summary create hubspot budget from budget
     * @request POST:/api/web/v1/budgets/{budget_id}/hubspot_budgets
     */
    webV1BudgetsHubspotBudgetsCreate: (
      budgetId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "hubspot_budget" */
            type?: string;
            attributes?: {
              /** @example "1" */
              id?: string;
              /** @example "Budget Name" */
              budget_name?: string;
              /** @example false */
              archived?: boolean;
              /** @example "2021-01-01T00:00:00Z" */
              created_at?: string;
              /** @example "2021-01-01T00:00:00Z" */
              updated_at?: string;
              /** @example "2021-01-01T00:00:00Z" */
              createdate?: string;
              /** @example "2021-01-01T00:00:00Z" */
              hs_lastmodifieddate?: string;
            };
          };
        },
        void
      >({
        path: `/api/web/v1/budgets/${budgetId}/hubspot_budgets`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Budgets, Web
     * @name WebV1BudgetsHubspotBudgetsCreate2
     * @summary links budget to hubspot budget
     * @request POST:/api/web/v1/budgets/{budget_id}/hubspot_budgets/{hubspot_budget_id}
     * @originalName webV1BudgetsHubspotBudgetsCreate
     * @duplicate
     */
    webV1BudgetsHubspotBudgetsCreate2: (
      budgetId: number,
      hubspotBudgetId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "budget" */
            type?: string;
            attributes?: {
              /** @example "Block 2024 Budget" */
              name?: string | null;
              /** @example "1" */
              company_id?: string;
              /** @example "Block 2024 Budget" */
              display_name?: string;
              /** @example "2024-01-01" */
              start_date?: string | null;
              /** @example "2024-12-31" */
              end_date?: string | null;
              success_metric?: {
                /** @example "Optimize it" */
                name?: string;
                /** @example "var(--spearmint-200)" */
                color?: string;
                /** @example "var(--spearmint-1000)" */
                text_color?: string;
                /** @example "fa-regular fa-credit-card" */
                icon?: string;
                /** @example "Optimize it...?" */
                description?: string;
              };
              order_target_information?: {
                /** @example 100 */
                order_target?: number | null;
                thresholds?: object;
              };
              relationships?: {
                budget_group?: {
                  data?: {
                    /** @example "1" */
                    id?: string;
                    /** @example "budget_group" */
                    type?: string;
                  }[];
                };
                budgets_users?: {
                  data?: {
                    /** @example "1" */
                    id?: string;
                    /** @example "budgets_users" */
                    type?: string;
                  }[];
                };
              };
            };
          };
        },
        void
      >({
        path: `/api/web/v1/budgets/${budgetId}/hubspot_budgets/${hubspotBudgetId}`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  buildings = {
    /**
     * No description
     *
     * @tags Building, Web
     * @name WebV1BuildingsCreateCreate
     * @summary create building
     * @request POST:/api/web/v1/buildings/create
     */
    webV1BuildingsCreateCreate: (
      data: {
        data?: {
          /** @example "building" */
          type?: string;
          attributes?: {
            /** @example "Creoria" */
            name?: string;
            /** @example "1" */
            distribution_center_id?: string;
            address?: {
              /** @example "123 Main St" */
              address1?: string;
              /** @example "" */
              address2?: string;
              /** @example "New York" */
              city?: string;
              /** @example "1" */
              state_id?: string;
              /** @example "11217" */
              zip?: string;
            };
          };
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "building" */
            type?: string;
            attributes?: {
              /** @example "Creoria" */
              name?: string;
              /** @example "1" */
              distribution_center_id?: string | number;
              address?: {
                /** @example "123 Main St" */
                address1?: string;
                /** @example "" */
                address2?: string;
                /** @example "New York" */
                city?: string;
                /** @example "1" */
                state_id?: string;
                /** @example "11217" */
                zip?: string;
              };
            };
            relationships?: {
              address?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "address" */
                  type?: string;
                };
              };
            };
          };
        },
        void
      >({
        path: `/api/web/v1/buildings/create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Building, Web
     * @name WebV1BuildingsRelationshipsSuitesList
     * @summary fetch all suites for building
     * @request GET:/api/web/v1/buildings/{building_id}/relationships/suites
     */
    webV1BuildingsRelationshipsSuitesList: (
      buildingId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Suite[];
        },
        void
      >({
        path: `/api/web/v1/buildings/${buildingId}/relationships/suites`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  categories = {
    /**
     * No description
     *
     * @tags Categories, Web
     * @name WebV1CategoriesList
     * @summary get list of categories & subcategories
     * @request GET:/api/web/v1/categories
     */
    webV1CategoriesList: (
      query?: {
        for_product_performance?: boolean;
        reporting_type?: string;
        "distributor_ids[]"?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Category[];
          included?: Subcategory[];
        },
        void
      >({
        path: `/api/web/v1/categories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  chains = {
    /**
     * No description
     *
     * @tags Chain, Web
     * @name WebV1ChainsCreate
     * @summary create chain
     * @request POST:/api/web/v1/chains
     */
    webV1ChainsCreate: (
      data: {
        chain: {
          corporate_user_id: number;
          purchasing_size_id: number;
          active: boolean;
          allow_multiple: boolean;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "chain" */
            type?: string;
            attributes?: {
              /** @example true */
              active?: boolean;
              /** @example "1" */
              purchasing_size_id?: number;
              /** @example false */
              global?: boolean;
              /** @example true */
              local?: boolean;
            };
          };
        },
        void
      >({
        path: `/api/web/v1/chains`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chain, Web
     * @name WebV1ChainsUpdate
     * @summary update chain
     * @request PUT:/api/web/v1/chains/{id}
     */
    webV1ChainsUpdate: (
      id: number,
      data: {
        chain?: {
          active?: boolean;
          allow_multiple?: boolean;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "chain" */
            type?: string;
            attributes?: {
              /** @example true */
              active?: boolean;
              /** @example "1" */
              purchasing_size_id?: number;
              /** @example false */
              global?: boolean;
              /** @example true */
              local?: boolean;
            };
          };
        },
        void
      >({
        path: `/api/web/v1/chains/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  client = {
    /**
     * No description
     *
     * @tags Budgets, Web
     * @name WebV1ClientBudgetsDetail
     * @summary a budget
     * @request GET:/api/web/v1/client/budgets/{id}
     */
    webV1ClientBudgetsDetail: (
      id: string,
      query?: {
        /** Delivery Date */
        delivery_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Budget;
        },
        void
      >({
        path: `/api/web/v1/client/budgets/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Budgets, Web
     * @name WebV1ClientBudgetsUpdate
     * @summary a budget
     * @request PUT:/api/web/v1/client/budgets/{id}
     */
    webV1ClientBudgetsUpdate: (
      id: string,
      data: {
        success_metric_type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Budget;
        },
        void
      >({
        path: `/api/web/v1/client/budgets/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products, Web
     * @name WebV1ClientCartActiveLocationUpdate
     * @summary set active cart location & account for user
     * @request PUT:/api/web/v1/client/cart/active_location/{location_id}
     */
    webV1ClientCartActiveLocationUpdate: (
      locationId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: object;
        },
        void
      >({
        path: `/api/web/v1/client/cart/active_location/${locationId}`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products, Web
     * @name WebV1ClientCartUpdateQuantityUpdate
     * @summary set active cart location & account for user
     * @request PUT:/api/web/v1/client/cart/update_quantity/{location_id}
     */
    webV1ClientCartUpdateQuantityUpdate: (
      locationId: number,
      query: {
        /** Purchasing size to update */
        purchasing_size_id: number;
        /** Quantity to set */
        quantity: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: object;
        },
        void
      >({
        path: `/api/web/v1/client/cart/update_quantity/${locationId}`,
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pantry, Web
     * @name WebV1ClientClientPurchasingSizesList
     * @summary pantry products index
     * @request GET:/api/web/v1/client/client_purchasing_sizes
     */
    webV1ClientClientPurchasingSizesList: (
      query: {
        /** Corporate user ID */
        corporate_user_id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "purchasing_size" */
            type?: string;
            attributes?: {
              /** @example "external_id" */
              external_id?: string;
              /** @example "100.00" */
              price?: string | null;
              /** @example "1.00" */
              unit_price?: string | null;
              /** @example 10 */
              marketplace_inventory?: number | null;
            };
            relationships?: {
              original_purchasing_size_groups?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "original_purchasing_size_group" */
                  type?: string;
                }[];
              };
              sku?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "sku" */
                  type?: string;
                };
              };
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/client/client_purchasing_sizes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pantry, Web
     * @name WebV1ClientClientPurchasingSizesCreate
     * @summary create pantry product
     * @request POST:/api/web/v1/client/client_purchasing_sizes
     */
    webV1ClientClientPurchasingSizesCreate: (
      data: {
        /** ID of the corporate user whose IC the client dp will be created for */
        corporate_user_id?: number;
        /** ID of the purchasing size to be added to the client inventory */
        purchasing_size_id?: number;
        /** Minimum inventory level for the client purchasing size */
        on_hand_inventory_minimum?: number;
        /** Target inventory level for the client purchasing size */
        on_hand_inventory_target_level?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "purchasing_size" */
            type?: string;
            attributes?: {
              /** @example "external_id" */
              external_id?: string;
              /** @example "100.00" */
              price?: string | null;
              /** @example "1.00" */
              unit_price?: string | null;
              /** @example 10 */
              marketplace_inventory?: number | null;
            };
            relationships?: {
              original_purchasing_size_groups?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "original_purchasing_size_group" */
                  type?: string;
                }[];
              };
              sku?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "sku" */
                  type?: string;
                };
              };
            };
          };
        },
        void
      >({
        path: `/api/web/v1/client/client_purchasing_sizes`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support, Web
     * @name WebV1ClientHubspotStagesList
     * @summary list of support ticket types
     * @request GET:/api/web/v1/client/hubspot_stages
     */
    webV1ClientHubspotStagesList: (params: RequestParams = {}) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "hubspot_stage" */
            type?: string;
            attributes?: {
              /** @example "some service type" */
              id?: string;
              /** @example "paused-circle" */
              icon_name?: string;
              /** @example "some service type" */
              value?: string;
              /** @example "color" */
              icon_color?: string;
              /** @example "some service type" */
              display_name?: string;
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/client/hubspot_stages`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations, Web, Client
     * @name WebV1ClientLocationsList
     * @summary list of client viewable locations
     * @request GET:/api/web/v1/client/locations
     */
    webV1ClientLocationsList: (params: RequestParams = {}) =>
      this.request<
        {
          data?: any[];
        },
        void
      >({
        path: `/api/web/v1/client/locations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pantry, Web
     * @name WebV1ClientMyPantrySwapProductCreate
     * @summary swap pantry product
     * @request POST:/api/web/v1/client/my_pantry/swap_product
     */
    webV1ClientMyPantrySwapProductCreate: (
      data: {
        current_product_id: number;
        replacement_product_id: number;
        target_stock_level?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          error?: string | null;
        },
        void | {
          success?: boolean;
          error?: string | null;
        }
      >({
        path: `/api/web/v1/client/my_pantry/swap_product`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pantry, Web
     * @name WebV1ClientMyPantryAccountsList
     * @summary list accounts for company
     * @request GET:/api/web/v1/client/my_pantry/accounts
     */
    webV1ClientMyPantryAccountsList: (params: RequestParams = {}) =>
      this.request<
        {
          data?: any[];
        },
        void
      >({
        path: `/api/web/v1/client/my_pantry/accounts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pantry, Web
     * @name WebV1ClientMyPantryActivityLogsList
     * @summary get activity logs
     * @request GET:/api/web/v1/client/my_pantry/{corporate_user_id}/activity_logs
     */
    webV1ClientMyPantryActivityLogsList: (
      corporateUserId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: ActivityLog[];
          included?: (
            | ActivityLogGroup
            | User
            | PurchasingSize
            | Sku
            | ProductSize
          )[];
        },
        void | {
          success?: boolean;
          error?: string | null;
        }
      >({
        path: `/api/web/v1/client/my_pantry/${corporateUserId}/activity_logs`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders, Web
     * @name WebV1ClientOrdersList
     * @summary list of client orders
     * @request GET:/api/web/v1/client/orders
     */
    webV1ClientOrdersList: (
      query?: {
        /** Fetch orders from this date (yyyy-mm-dd) */
        from?: string;
        /** Fetch orders to this date (yyyy-mm-dd) */
        to?: string;
        /** Filter orders by location ids */
        locations?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: FinalizedPurchase[];
        },
        void
      >({
        path: `/api/web/v1/client/orders`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders, Web
     * @name WebV1ClientOrdersGroupsList
     * @summary client order with groups
     * @request GET:/api/web/v1/client/orders/{id}/groups
     */
    webV1ClientOrdersGroupsList: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: FinalizedPurchase;
          included?: (OriginalPurchasingSizeGroup | PurchasingSize)[];
        },
        void
      >({
        path: `/api/web/v1/client/orders/${id}/groups`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders, Web
     * @name WebV1ClientOrdersDetail
     * @summary a client order
     * @request GET:/api/web/v1/client/orders/{id}
     */
    webV1ClientOrdersDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: FinalizedPurchase;
          included?: (OriginalPurchasingSizeGroup | ProductSize | Sku | Tag)[];
        },
        void
      >({
        path: `/api/web/v1/client/orders/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders, Web
     * @name WebV1ClientOrdersItemsList
     * @summary client order items
     * @request GET:/api/web/v1/client/orders/{id}/items
     */
    webV1ClientOrdersItemsList: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: PurchasingSize[];
          included?: (OriginalPurchasingSizeGroup | ProductSize | Sku | Tag)[];
        },
        void
      >({
        path: `/api/web/v1/client/orders/${id}/items`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders, Web
     * @name WebV1ClientOrdersUpdateProductQuantityUpdate
     * @summary update product quantity
     * @request PUT:/api/web/v1/client/orders/{id}/update_product_quantity
     */
    webV1ClientOrdersUpdateProductQuantityUpdate: (
      id: string,
      query: {
        /** ID of the purchasing size we are changing quantity of */
        purchasing_size_id: number;
        /** New quantity of the purchasing size */
        quantity: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: FinalizedPurchase;
          included?: OriginalPurchasingSizeGroup[];
        },
        void
      >({
        path: `/api/web/v1/client/orders/${id}/update_product_quantity`,
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders, Web
     * @name WebV1ClientOrdersActivityLogsList
     * @summary order activity logs
     * @request GET:/api/web/v1/client/orders/{id}/activity_logs
     */
    webV1ClientOrdersActivityLogsList: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: ActivityLog[];
          included?: (ActivityLogGroup | User | PurchasingSize | Sku)[];
        },
        void
      >({
        path: `/api/web/v1/client/orders/${id}/activity_logs`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders, Web
     * @name WebV1ClientOrdersCreateImplementationOrderCreate
     * @summary create implementation order
     * @request POST:/api/web/v1/client/orders/create_implementation_order
     */
    webV1ClientOrdersCreateImplementationOrderCreate: (
      query: {
        /** ID of the corporate user for whom the order is being created */
        corporate_user_id: number;
        /** Delivery date for the order (yyyy-mm-dd) */
        start_date: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: FinalizedPurchase;
          included?: (OriginalPurchasingSizeGroup | ProductSize | Sku | Tag)[];
        },
        void
      >({
        path: `/api/web/v1/client/orders/create_implementation_order`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pantry, Web
     * @name WebV1ClientMyPantryPantryProductRecommendationsList
     * @summary get AI product suggestions
     * @request GET:/api/web/v1/client/my_pantry/{corporate_user_id}/pantry_product_recommendations
     */
    webV1ClientMyPantryPantryProductRecommendationsList: (
      corporateUserId: number,
      query: {
        /** Product ID for suggestions */
        product_id?: number;
        /** Type of recommendation to fetch */
        recommendation_type: string;
        /** Search term for filtering results */
        search_term?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: any[];
        },
        void
      >({
        path: `/api/web/v1/client/my_pantry/${corporateUserId}/pantry_product_recommendations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products, Web
     * @name WebV1ClientProductsBuyAgainProductsList
     * @summary client buy again for products
     * @request GET:/api/web/v1/client/products/buy_again_products
     */
    webV1ClientProductsBuyAgainProductsList: (
      query: {
        /** Target delivery date for product availability */
        delivery_date: string;
        /** Finalized purchase to filter previously purchased products by account */
        finalized_purchase_id?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: any[];
          included?: (Brand | Product | ProductSize | Sku | Tag)[];
        },
        void
      >({
        path: `/api/web/v1/client/products/buy_again_products`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products, Web
     * @name WebV1ClientProductsSuggestedProductsList
     * @summary suggested products
     * @request GET:/api/web/v1/client/products/suggested_products
     */
    webV1ClientProductsSuggestedProductsList: (
      query: {
        finalized_purchase_id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: any[];
          included?: (Brand | Product | ProductSize | Sku | Tag)[];
        },
        void
      >({
        path: `/api/web/v1/client/products/suggested_products`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products, Web
     * @name WebV1ClientProductsSearchList
     * @summary client search for products
     * @request GET:/api/web/v1/client/products/search
     */
    webV1ClientProductsSearchList: (
      query: {
        /** Region to search over */
        distribution_center_id: number;
        /** Target delivery date for product availability */
        delivery_date: string;
        /** Search text to filter products by */
        search_text?: string;
        /** Finalized purchase to filter previously purchased products by account */
        finalized_purchase_id?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: any[];
          included?: (Brand | Product | ProductSize | Sku | Tag)[];
        },
        void
      >({
        path: `/api/web/v1/client/products/search`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products, Web
     * @name WebV1ClientProductsTopByCollectionList
     * @summary list of top products by collection
     * @request GET:/api/web/v1/client/products/top_by_collection
     */
    webV1ClientProductsTopByCollectionList: (
      query: {
        /** Location to filter by */
        location_id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: object;
        },
        void
      >({
        path: `/api/web/v1/client/products/top_by_collection`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products, Web
     * @name WebV1ClientProductsCollectionsDetail
     * @summary paginated list of products within given collection
     * @request GET:/api/web/v1/client/products/collections/{collection_id}
     */
    webV1ClientProductsCollectionsDetail: (
      collectionId: number,
      query: {
        /** Location to filter by */
        location_id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: object;
        },
        void
      >({
        path: `/api/web/v1/client/products/collections/${collectionId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products, Web
     * @name WebV1ClientProductsCollectionsList
     * @summary list of collections that have displayable products
     * @request GET:/api/web/v1/client/products/collections
     */
    webV1ClientProductsCollectionsList: (
      query: {
        /** Location to filter by */
        location_id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: object;
        },
        void
      >({
        path: `/api/web/v1/client/products/collections`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products, Web
     * @name WebV1ClientProductsSubcategoriesList
     * @summary list of subcategories
     * @request GET:/api/web/v1/client/products/subcategories
     */
    webV1ClientProductsSubcategoriesList: (
      query: {
        /** Location to filter by */
        location_id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id: string;
            type: "subcategory";
            attributes?: {
              /** @example "drinks" */
              name?: string;
              /** @example 1 */
              category_id?: number;
            };
            relationships?: {
              category?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "category" */
                  type?: string;
                };
              };
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/client/products/subcategories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products, Web
     * @name WebV1ClientProductsAvailableTagsList
     * @summary list of tags you could filter active collections by
     * @request GET:/api/web/v1/client/products/available_tags
     */
    webV1ClientProductsAvailableTagsList: (
      query: {
        /** Location to filter by */
        location_id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: any[];
        },
        any
      >({
        path: `/api/web/v1/client/products/available_tags`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products, Web
     * @name WebV1ClientProductsDetailsList
     * @summary get details about given products for a given location
     * @request GET:/api/web/v1/client/products/details
     */
    webV1ClientProductsDetailsList: (
      query: {
        /** List of details to fetch */
        "details[]": (
          | "popular"
          | "price"
          | "recently_purchased"
          | "all_tags"
          | "image"
        )[];
        /** params needed for certain details */
        details_params?: {
          /** @example 1 */
          distribution_center_id?: number;
          /** @example 1 */
          corporate_user_id?: number;
        };
        "purchasing_size_ids[]": string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: any[];
          included?: (Sku | Tag)[];
        },
        any
      >({
        path: `/api/web/v1/client/products/details`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Client, Web
     * @name WebV1ClientSchedulesDetail
     * @summary view events for the given dates at the given location
     * @request GET:/api/web/v1/client/schedules/{membership_id}
     */
    webV1ClientSchedulesDetail: (
      membershipId: number,
      query?: {
        start_date?: string;
        end_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Schedule;
        },
        void
      >({
        path: `/api/web/v1/client/schedules/${membershipId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support, Web
     * @name WebV1ClientSupportTicketTypesList
     * @summary list of support ticket types
     * @request GET:/api/web/v1/client/support/ticket_types
     */
    webV1ClientSupportTicketTypesList: (params: RequestParams = {}) =>
      this.request<
        {
          id: number;
          label: string;
          value: string;
        }[],
        void
      >({
        path: `/api/web/v1/client/support/ticket_types`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support, Web
     * @name WebV1ClientSupportClientLocationsList
     * @summary list of viewable hubspot locations
     * @request GET:/api/web/v1/client/support/client_locations
     */
    webV1ClientSupportClientLocationsList: (params: RequestParams = {}) =>
      this.request<
        {
          label: string;
          value: number;
        }[],
        void
      >({
        path: `/api/web/v1/client/support/client_locations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Support, Web
     * @name WebV1ClientSupportCreate
     * @summary create a support ticket
     * @request POST:/api/web/v1/client/support
     */
    webV1ClientSupportCreate: (
      data: {
        subject: string;
        content: string;
        location_id: number;
        priority: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/client/support`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Client, Web
     * @name WebV1ClientUsersUpdatePasswordUpdate
     * @summary update password
     * @request PUT:/api/web/v1/client/users/update_password
     */
    webV1ClientUsersUpdatePasswordUpdate: (
      data: {
        /** @example "password" */
        current_password: string;
        /** @example "password" */
        password: string;
        /** @example "password" */
        password_confirmation: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/client/users/update_password`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Unwrapped, Web
     * @name WebV1ClientUnwrappedList
     * @summary view your unwrapped data for this year
     * @request GET:/api/web/v1/client/unwrapped
     */
    webV1ClientUnwrappedList: (
      query?: {
        /** One of your locations to filter by */
        location_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Unwrapped2024;
        },
        void
      >({
        path: `/api/web/v1/client/unwrapped`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Unwrapped, Web
     * @name WebV1ClientUnwrappedGenerateMagicLinkCreate
     * @summary generate a magic link for a user's or location's unwrapped
     * @request POST:/api/web/v1/client/unwrapped/generate_magic_link
     */
    webV1ClientUnwrappedGenerateMagicLinkCreate: (
      query?: {
        /** One of your locations to filter by */
        location_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: any;
        },
        void
      >({
        path: `/api/web/v1/client/unwrapped/generate_magic_link`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),
  };
  closures = {
    /**
     * No description
     *
     * @tags Closure, Web
     * @name WebV1ClosuresCreate
     * @summary create closure
     * @request POST:/api/web/v1/closures
     */
    webV1ClosuresCreate: (
      data: {
        closure?: {
          /** @example "12/01/2024" */
          start_date?: string;
          /** @example "12/06/2024" */
          end_date?: string;
          /** @example "holiday" */
          closure_type?: string;
          /** @example "Friendsgiving" */
          closure_reason?: string;
          /** @example "1" */
          company_id?: string;
          /** @example "1" */
          distribution_center_id?: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string | null;
            /** @example "closure" */
            type?: string;
            attributes?: {
              /** @example "12/01/2024" */
              start_date?: string;
              /** @example "12/06/2024" */
              end_date?: string;
              /** @example "holiday" */
              closure_type?: string;
              /** @example "Friendsgiving" */
              closure_reason?: string;
              /** @example "1" */
              company_id?: number;
              /** @example "1" */
              distribution_center_id?: number | null;
            };
          };
        },
        void
      >({
        path: `/api/web/v1/closures`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Closure, Web
     * @name WebV1ClosuresBuildCreate
     * @summary build closure
     * @request POST:/api/web/v1/closures/build
     */
    webV1ClosuresBuildCreate: (
      data: {
        closure?: {
          /** @example "12/01/2024" */
          start_date?: string;
          /** @example "12/06/2024" */
          end_date?: string;
          /** @example "holiday" */
          closure_type?: string;
          /** @example "Friendsgiving" */
          closure_reason?: string;
          /** @example "1" */
          company_id?: string;
          /** @example "1" */
          distribution_center_id?: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string | null;
            /** @example "closure" */
            type?: string;
            attributes?: {
              /** @example "12/01/2024" */
              start_date?: string;
              /** @example "12/06/2024" */
              end_date?: string;
              /** @example "holiday" */
              closure_type?: string;
              /** @example "Friendsgiving" */
              closure_reason?: string;
              /** @example "1" */
              company_id?: number;
              /** @example "1" */
              distribution_center_id?: number | null;
            };
          };
        },
        void
      >({
        path: `/api/web/v1/closures/build`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Closure, Web
     * @name WebV1ClosuresUsersAccountsList
     * @summary get user accounts for the order dashboard
     * @request GET:/api/web/v1/closures/users_accounts
     */
    webV1ClosuresUsersAccountsList: (params: RequestParams = {}) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "corporate_user" */
            type?: string;
            attributes?: {
              /** @example "pantry" */
              program?: string;
              /** @example "drop_and_go" */
              service_type?: string | null;
              /** @example 0.1 */
              order_fee_decimal?: float | null;
              /** @example 10 */
              prepayment_percent?: number | null;
              /** @example "deliveries should be made at the back" */
              delivery_instructions?: string | null;
              /** @example "2024-04-26T03:00:00.000Z" */
              speedy_delivery_cutoff?: string | null;
              /** @example "pickups should be made at the front" */
              pickup_instructions?: string | null;
              /** @example true */
              send_missed_items?: boolean | null;
              /** @example true */
              allow_chains?: boolean;
              /** @example "inventory" */
              ic_order_method?: string | null;
              /** @example true */
              overnight?: boolean;
              /** @example "budget notes" */
              budget_notes?: string | null;
              /** @example 1 */
              default_budget_id?: number | null;
              /** @example 1 */
              suite_id?: number | null;
              /** @example "nickname" */
              nickname?: string | null;
            };
            relationships?: {
              suite?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "suite" */
                  type?: string;
                };
              };
              company?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "company" */
                  type?: string;
                };
              };
              companies_users?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "companies_user" */
                  type?: string;
                  attributes?: {
                    /** @example "dashboard_user" */
                    relationship?: string;
                    /** @example "1" */
                    company_id?: string;
                    /** @example "1" */
                    corporate_user_id?: string;
                    /** @example "1" */
                    user_id?: string;
                  };
                }[];
              };
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/closures/users_accounts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Closure, Web
     * @name WebV1ClosuresClientClosuresList
     * @summary get client closures
     * @request GET:/api/web/v1/closures/client_closures
     */
    webV1ClosuresClientClosuresList: (
      query?: {
        params?: {
          /** @example 1 */
          company_id?: number;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string | null;
            /** @example "closure" */
            type?: string;
            attributes?: {
              /** @example "12/01/2024" */
              start_date?: string;
              /** @example "12/06/2024" */
              end_date?: string;
              /** @example "holiday" */
              closure_type?: string;
              /** @example "Friendsgiving" */
              closure_reason?: string;
              /** @example "1" */
              company_id?: number;
              /** @example "1" */
              distribution_center_id?: number | null;
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/closures/client_closures`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Closure, Web
     * @name WebV1ClosuresClientClosuresCreate
     * @summary create client closure
     * @request POST:/api/web/v1/closures/client_closures
     */
    webV1ClosuresClientClosuresCreate: (
      data: {
        closure?: {
          /** @example "12/01/2024" */
          start_date?: string;
          /** @example "12/06/2024" */
          end_date?: string;
          /** @example "holiday" */
          closure_type?: string;
          /** @example "Friendsgiving" */
          closure_reason?: string;
          /** @example "1" */
          company_id?: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string | null;
            /** @example "closure" */
            type?: string;
            attributes?: {
              /** @example "12/01/2024" */
              start_date?: string;
              /** @example "12/06/2024" */
              end_date?: string;
              /** @example "holiday" */
              closure_type?: string;
              /** @example "Friendsgiving" */
              closure_reason?: string;
              /** @example "1" */
              company_id?: number;
              /** @example "1" */
              distribution_center_id?: number | null;
            };
          };
        },
        void
      >({
        path: `/api/web/v1/closures/client_closures`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Closure, Web
     * @name WebV1ClosuresDelete
     * @summary delete closures
     * @request DELETE:/api/web/v1/closures/{id}
     */
    webV1ClosuresDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/web/v1/closures/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  companies = {
    /**
     * No description
     *
     * @tags Companies, Web
     * @name WebV1CompaniesRelationshipsNavigationItemsList
     * @summary get locations for a company
     * @request GET:/api/web/v1/companies/{company_id}/relationships/navigation_items
     */
    webV1CompaniesRelationshipsNavigationItemsList: (
      companyId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: NavigationItem[];
        },
        void
      >({
        path: `/api/web/v1/companies/${companyId}/relationships/navigation_items`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies, Web
     * @name WebV1CompaniesRelationshipsMembershipsList
     * @summary get memberships for a company
     * @request GET:/api/web/v1/companies/{company_id}/relationships/memberships
     */
    webV1CompaniesRelationshipsMembershipsList: (
      companyId: number,
      query?: {
        /** @example "false" */
        "filter[archived]"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: any[];
        },
        void
      >({
        path: `/api/web/v1/companies/${companyId}/relationships/memberships`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies, Web
     * @name WebV1CompaniesRelationshipsBudgetsList
     * @summary get budgets for a company
     * @request GET:/api/web/v1/companies/{company_id}/relationships/budgets
     */
    webV1CompaniesRelationshipsBudgetsList: (
      companyId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Budget[];
        },
        void
      >({
        path: `/api/web/v1/companies/${companyId}/relationships/budgets`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies, Web
     * @name WebV1CompaniesRelationshipsExternalUsersList
     * @summary get external users for a company
     * @request GET:/api/web/v1/companies/{company_id}/relationships/external_users
     */
    webV1CompaniesRelationshipsExternalUsersList: (
      companyId: number,
      query?: {
        /** @example "false" */
        "filter[archived]"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: ExternalUser[];
        },
        void
      >({
        path: `/api/web/v1/companies/${companyId}/relationships/external_users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies, Web
     * @name WebV1CompaniesHubspotProfileList
     * @summary get hubspot profile for a company
     * @request GET:/api/web/v1/companies/{id}/hubspot_profile
     */
    webV1CompaniesHubspotProfileList: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: HubspotCompany;
        },
        void
      >({
        path: `/api/web/v1/companies/${id}/hubspot_profile`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Budgets, Web
     * @name WebV1CompaniesHubspotBudgetsList
     * @summary fetch hubspot budgets by company
     * @request GET:/api/web/v1/companies/{company_id}/hubspot_budgets
     */
    webV1CompaniesHubspotBudgetsList: (
      companyId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "hubspot_budget" */
            type?: string;
            attributes?: {
              /** @example "1" */
              id?: string;
              /** @example "Budget Name" */
              budget_name?: string;
              /** @example false */
              archived?: boolean;
              /** @example "2021-01-01T00:00:00Z" */
              created_at?: string;
              /** @example "2021-01-01T00:00:00Z" */
              updated_at?: string;
              /** @example "2021-01-01T00:00:00Z" */
              createdate?: string;
              /** @example "2021-01-01T00:00:00Z" */
              hs_lastmodifieddate?: string;
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/companies/${companyId}/hubspot_budgets`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  craftyHolidays = {
    /**
     * No description
     *
     * @tags Crafty Holidays, Web
     * @name WebV1CraftyHolidaysList
     * @summary get crafty holidays
     * @request GET:/api/web/v1/crafty_holidays
     */
    webV1CraftyHolidaysList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "1" */
          id?: string;
          /** @example "crafty_holiday" */
          type?: string;
          attributes?: {
            /** @example "Christmas Day" */
            name?: string;
            /** @example 2024 */
            year?: number;
            /** @example "2024-12-25" */
            date?: string;
            /** @example "Dec 25" */
            month_day?: string;
          };
        },
        any
      >({
        path: `/api/web/v1/crafty_holidays`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Crafty Holidays, Web
     * @name WebV1CraftyHolidaysEditableList
     * @summary get editable crafty holidays
     * @request GET:/api/web/v1/crafty_holidays/editable
     */
    webV1CraftyHolidaysEditableList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "1" */
          id?: string;
          /** @example "crafty_holiday" */
          type?: string;
          attributes?: {
            /** @example "Christmas Day" */
            name?: string;
            /** @example 2024 */
            year?: number;
            /** @example "2024-12-25" */
            date?: string;
            /** @example "Dec 25" */
            month_day?: string;
          };
        },
        any
      >({
        path: `/api/web/v1/crafty_holidays/editable`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Crafty Holidays, Web
     * @name WebV1CraftyHolidaysBulkUpdateUpdate
     * @summary bulk update crafty holidays
     * @request PUT:/api/web/v1/crafty_holidays/bulk_update
     */
    webV1CraftyHolidaysBulkUpdateUpdate: (
      data: {
        data?: {
          active?: boolean;
          international?: boolean;
          name?: string;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/crafty_holidays/bulk_update`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  distributionCenters = {
    /**
     * No description
     *
     * @tags Distribution Centers, Web
     * @name WebV1DistributionCentersList
     * @summary get list of distribution centers
     * @request GET:/api/web/v1/distribution_centers
     */
    webV1DistributionCentersList: (
      query?: {
        direct?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "distribution_center" */
            type?: string;
            attributes?: {
              /** @example "Chicago" */
              name?: string;
              /** @example "CHI" */
              abbreviation?: string;
              /** @example false */
              all_accounts_archived?: boolean;
              distribution_type?: "direct" | "indirect";
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/distribution_centers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Distribution Centers, Web
     * @name WebV1DistributionCentersBuildingsList
     * @summary get buildings for a distribution center
     * @request GET:/api/web/v1/distribution_centers/{id}/buildings
     */
    webV1DistributionCentersBuildingsList: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "building" */
            type?: string;
            attributes?: {
              /** @example "Creoria" */
              name?: string | nil;
            };
            relationships?: {
              address?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "address" */
                  type?: string;
                };
              };
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/distribution_centers/${id}/buildings`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  distributors = {
    /**
     * No description
     *
     * @tags Distributors, Web
     * @name WebV1DistributorsList
     * @summary get list of distributors
     * @request GET:/api/web/v1/distributors
     */
    webV1DistributorsList: (
      query?: {
        direct?: boolean;
        "distribution_center_ids[]"?: string[];
        "subcategory_ids[]"?: string[];
        "brand_ids[]"?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "distributor" */
            type?: string;
            attributes?: {
              /** @example "Distributor A" */
              name?: string;
              /** @example "Distributor A - CHI" */
              name_with_abv?: string;
              /** @example false */
              partner_branch?: boolean;
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/distributors`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  externalUsers = {
    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersRelationshipsCorporateUsersList
     * @summary get accounts for a user
     * @request GET:/api/web/v1/external_users/{external_user_id}/relationships/corporate_users
     */
    webV1ExternalUsersRelationshipsCorporateUsersList: (
      externalUserId: number,
      query?: {
        /** @example "false" */
        "filter[archived]"?: string;
        "filter[distribution_center][]"?: (string | null)[];
        /** @example "suite 245" */
        "filter[query]"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: CorporateUser[];
        },
        void
      >({
        path: `/api/web/v1/external_users/${externalUserId}/relationships/corporate_users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersRelationshipsDashboardMembershipsList
     * @summary gets platform memberships for a user
     * @request GET:/api/web/v1/external_users/{external_user_id}/relationships/dashboard_memberships
     */
    webV1ExternalUsersRelationshipsDashboardMembershipsList: (
      externalUserId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "membership" */
            type?: string;
            attributes?: {
              /** @example "some_service_type" */
              service_type?: string;
              /** @example 1 */
              building_id?: number;
              /** @example 2 */
              hubspot_location_id?: number | null;
              /** @example 99.99 */
              delivery_fee?: float | null;
              /** @example "Some Building Name" */
              building_display_name?: string;
              /** @example "Some delivery instructions" */
              delivery_instructions?: string | null;
            };
            relationships?: {
              delivery_contact?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "delivery_contact" */
                  type?: string;
                };
              };
              company?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "company" */
                  type?: string;
                };
              };
              distribution_center?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "distribution_center" */
                  type?: string;
                };
              };
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/external_users/${externalUserId}/relationships/dashboard_memberships`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersRelationshipsBillingProfilesList
     * @summary get billing profiles for a user
     * @request GET:/api/web/v1/external_users/{external_user_id}/relationships/billing_profiles
     */
    webV1ExternalUsersRelationshipsBillingProfilesList: (
      externalUserId: number,
      query?: {
        /** @example "false" */
        "filter[archived]"?: string;
        /** @example "mr name" */
        "filter[query]"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: BillingProfile[];
        },
        void
      >({
        path: `/api/web/v1/external_users/${externalUserId}/relationships/billing_profiles`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersRelationshipsCompaniesUsersCreate
     * @summary creates many companies users to a user
     * @request POST:/api/web/v1/external_users/{external_user_id}/relationships/companies_users
     */
    webV1ExternalUsersRelationshipsCompaniesUsersCreate: (
      externalUserId: number,
      data: {
        data?: {
          /** @example "companies_user" */
          type?: string;
          attributes?: {
            /** @example "dashboard_user" */
            relationship?: string;
            /** @example "1" */
            corporate_user_id?: string | null;
            /** @example "1" */
            owner_id?: string | null;
            /** @example "Membership" */
            owner_type?: string | null;
          };
        }[];
        /** @example false */
        log_as_bulk_action?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: CompaniesUser[];
        },
        void
      >({
        path: `/api/web/v1/external_users/${externalUserId}/relationships/companies_users`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersRelationshipsCompaniesUsersBulkDeleteCreate
     * @summary delete companies users associated with a user
     * @request POST:/api/web/v1/external_users/{external_user_id}/relationships/companies_users/bulk_delete
     */
    webV1ExternalUsersRelationshipsCompaniesUsersBulkDeleteCreate: (
      externalUserId: number,
      data: {
        data?: {
          /** @example "companies_user" */
          type?: string;
          attributes?: {
            /** @example "dashboard_user" */
            relationship?: string;
            /** @example "1" */
            corporate_user_id?: string;
          };
        }[];
        /** @example false */
        log_as_bulk_action?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/api/web/v1/external_users/${externalUserId}/relationships/companies_users/bulk_delete`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersRelationshipsDistributionCentersList
     * @summary get all dcs connected to this user's accounts
     * @request GET:/api/web/v1/external_users/{external_user_id}/relationships/distribution_centers
     */
    webV1ExternalUsersRelationshipsDistributionCentersList: (
      externalUserId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: DistributionCenter[];
        },
        void
      >({
        path: `/api/web/v1/external_users/${externalUserId}/relationships/distribution_centers`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersRelationshipsBillingProfilesUsersCreate
     * @summary creates many billing profiles users to a user
     * @request POST:/api/web/v1/external_users/{external_user_id}/relationships/billing_profiles_users
     */
    webV1ExternalUsersRelationshipsBillingProfilesUsersCreate: (
      externalUserId: number,
      data: {
        data?: {
          /** @example "billing_profiles_user" */
          type?: string;
          attributes?: {
            /** @example "view_user" */
            relationship?: string;
            /** @example "1" */
            billing_profile_id?: string;
          };
        }[];
        /** @example false */
        log_as_bulk_action?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "billing_profiles_user" */
            type?: string;
            attributes?: {
              /** @example "view_user" */
              relationship?: string;
              /** @example 1 */
              billing_profile_id?: number;
              /** @example 1 */
              user_id?: number;
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/external_users/${externalUserId}/relationships/billing_profiles_users`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersRelationshipsBillingProfilesUsersBulkDeleteCreate
     * @summary delete billing profiles users associated with a user
     * @request POST:/api/web/v1/external_users/{external_user_id}/relationships/billing_profiles_users/bulk_delete
     */
    webV1ExternalUsersRelationshipsBillingProfilesUsersBulkDeleteCreate: (
      externalUserId: number,
      data: {
        data?: {
          /** @example "billing_profiles_user" */
          type?: string;
          attributes?: {
            /** @example "view_user" */
            relationship?: string;
            /** @example "1" */
            billing_profile_id?: string;
          };
        }[];
        /** @example false */
        log_as_bulk_action?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/api/web/v1/external_users/${externalUserId}/relationships/billing_profiles_users/bulk_delete`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersRelationshipsBudgetsList
     * @summary get budgets for a user
     * @request GET:/api/web/v1/external_users/{external_user_id}/relationships/budgets
     */
    webV1ExternalUsersRelationshipsBudgetsList: (
      externalUserId: number,
      query?: {
        /** @example "false" */
        "filter[archived]"?: string;
        /** @example "Q4 Budget" */
        "filter[query]"?: string;
        "filter[budget_group][]"?: (string | null)[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/external_users/${externalUserId}/relationships/budgets`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersRelationshipsBudgetsUsersCreate
     * @summary creates many budgets users to a user
     * @request POST:/api/web/v1/external_users/{external_user_id}/relationships/budgets_users
     */
    webV1ExternalUsersRelationshipsBudgetsUsersCreate: (
      externalUserId: number,
      data: {
        data?: {
          /** @example "budgets_user" */
          type?: string;
          attributes?: {
            /** @example "view_user" */
            relationship?: string;
            /** @example "1" */
            budget_id?: string;
          };
        }[];
        /** @example false */
        log_as_bulk_action?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "budgets_user" */
            type?: string;
            attributes?: {
              /** @example "view_user" */
              relationship?: string;
              /** @example 1 */
              budget_id?: number;
              /** @example 1 */
              user_id?: number;
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/external_users/${externalUserId}/relationships/budgets_users`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersRelationshipsBudgetsUsersBulkDeleteCreate
     * @summary delete budgets users associated with a user
     * @request POST:/api/web/v1/external_users/{external_user_id}/relationships/budgets_users/bulk_delete
     */
    webV1ExternalUsersRelationshipsBudgetsUsersBulkDeleteCreate: (
      externalUserId: number,
      data: {
        data?: {
          /** @example "budgets_user" */
          type?: string;
          attributes?: {
            /** @example "view_user" */
            relationship?: string;
            /** @example "1" */
            budget_id?: string;
          };
        }[];
        /** @example false */
        log_as_bulk_action?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/api/web/v1/external_users/${externalUserId}/relationships/budgets_users/bulk_delete`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersDetail
     * @summary get data for the given external user
     * @request GET:/api/web/v1/external_users/{external_user_id}
     */
    webV1ExternalUsersDetail: (
      externalUserId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "external_user" */
            type?: string;
            attributes?: {
              /** @example "John" */
              first_name?: string;
              /** @example "Doe" */
              last_name?: string;
              /** @example "john@craftydelivers.com" */
              email?: string;
              /** @example "7184551234" */
              phone?: string | null;
              /** @example "he/him" */
              pronouns?: string | null;
              /** @example "1" */
              user_roles?: number[];
              /** @example 1 */
              user_id?: number;
            };
          };
        },
        void
      >({
        path: `/api/web/v1/external_users/${externalUserId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersUpdate
     * @summary update external user
     * @request PUT:/api/web/v1/external_users/{external_user_id}
     */
    webV1ExternalUsersUpdate: (
      externalUserId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "external_user" */
            type?: string;
            attributes?: {
              /** @example "John" */
              first_name?: string;
              /** @example "Doe" */
              last_name?: string;
              /** @example "john@craftydelivers.com" */
              email?: string;
              /** @example "7184551234" */
              phone?: string | null;
              /** @example "he/him" */
              pronouns?: string | null;
              /** @example "1" */
              user_roles?: number[];
              /** @example 1 */
              user_id?: number;
            };
          };
        },
        void
      >({
        path: `/api/web/v1/external_users/${externalUserId}`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users, Web
     * @name WebV1ExternalUsersCreateCreate
     * @summary create new external user
     * @request POST:/api/web/v1/external_users/create
     */
    webV1ExternalUsersCreateCreate: (
      data: {
        /** @example "John" */
        first_name?: string;
        /** @example "Doe" */
        last_name?: string;
        /** @example "john@craftydelivers.com" */
        email?: string;
        /** @example "7184551234" */
        phone?: string | null;
        /** @example "he/him" */
        pronouns?: string | null;
        /** @example 1 */
        company_id?: number;
        /** @example "1" */
        user_roles?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "external_user" */
            type?: string;
            attributes?: {
              /** @example "John" */
              first_name?: string;
              /** @example "Doe" */
              last_name?: string;
              /** @example "john@craftydelivers.com" */
              email?: string;
              /** @example "7184551234" */
              phone?: string | null;
              /** @example "he/him" */
              pronouns?: string | null;
              /** @example "1" */
              user_roles?: number[];
              /** @example 1 */
              user_id?: number;
            };
          };
        },
        void
      >({
        path: `/api/web/v1/external_users/create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  finalizedPurchases = {
    /**
     * No description
     *
     * @tags Finalized Purchases, Web
     * @name WebV1FinalizedPurchasesMoveToDashboardCreate
     * @summary move finalized purchase to client platform
     * @request POST:/api/web/v1/finalized_purchases/{id}/move_to_dashboard
     */
    webV1FinalizedPurchasesMoveToDashboardCreate: (
      id: number,
      data: {
        /** @example "1" */
        id: string;
        /** @example 2 */
        user_id: number;
        email: {
          /** @example true */
          send_email_notification?: boolean;
          /** @example [10] */
          recipients?: number[];
          /** @example "Subject" */
          subject?: string;
          /** @example "First line" */
          first_line?: string;
          /** @example "Body" */
          body?: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: FinalizedPurchase;
        },
        void
      >({
        path: `/api/web/v1/finalized_purchases/${id}/move_to_dashboard`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Finalized Purchases, Web
     * @name WebV1FinalizedPurchasesDelete
     * @summary Soft delete an order
     * @request DELETE:/api/web/v1/finalized_purchases/{id}
     */
    webV1FinalizedPurchasesDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/web/v1/finalized_purchases/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Finalized Purchases, Web
     * @name WebV1FinalizedPurchasesRelationshipsDocumentsCreate
     * @summary add document to order
     * @request POST:/api/web/v1/finalized_purchases/{id}/relationships/documents
     */
    webV1FinalizedPurchasesRelationshipsDocumentsCreate: (
      id: number,
      data: File,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Document;
        },
        void
      >({
        path: `/api/web/v1/finalized_purchases/${id}/relationships/documents`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Finalized Purchases, Web
     * @name WebV1FinalizedPurchasesRelationshipsDocumentsDelete
     * @summary remove document from order
     * @request DELETE:/api/web/v1/finalized_purchases/{id}/relationships/documents/{document_id}
     */
    webV1FinalizedPurchasesRelationshipsDocumentsDelete: (
      id: number,
      documentId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/finalized_purchases/${id}/relationships/documents/${documentId}`,
        method: "DELETE",
        ...params,
      }),
  };
  hubspotTicketTypes = {
    /**
     * No description
     *
     * @tags Support, Web
     * @name WebV1HubspotTicketTypesList
     * @summary list of support ticket types
     * @request GET:/api/web/v1/hubspot_ticket_types
     */
    webV1HubspotTicketTypesList: (params: RequestParams = {}) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "hubspot_ticket_type" */
            type?: string;
            attributes?: {
              /** @example "some service type" */
              label?: string;
              /** @example "some_service_type" */
              value?: string;
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/hubspot_ticket_types`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  internalUsers = {
    /**
     * No description
     *
     * @tags Users, Web
     * @name WebV1InternalUsersList
     * @summary get users
     * @request GET:/api/web/v1/internal_users
     */
    webV1InternalUsersList: (
      query?: {
        fields?: any[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/internal_users`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  margins = {
    /**
     * No description
     *
     * @tags Margins, Web
     * @name WebV1MarginsAvailableOptionsList
     * @summary get list of items a margin could be applied to
     * @request GET:/api/web/v1/margins/available_options
     */
    webV1MarginsAvailableOptionsList: (
      query: {
        margin_level: string;
        "subcategories[]"?: string[];
        "brands[]"?: string[];
        "markets[]"?: string[];
        "distributors[]"?: string[];
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string | nil;
            type?: "margin";
            attributes?: {
              /** @example "1-1-1-1" */
              reference_id?: string;
              /** @example 50 */
              percentage?: number | nil;
              /** @example true */
              needs_sync?: boolean | nil;
              /** @example "subcategory_default" */
              margin_level_value?: string;
              /** @example 1 */
              subcategory_id?: number | nil;
              /** @example 1 */
              distribution_center_id?: number | nil;
              /** @example 1 */
              brand_id?: number | nil;
              /** @example 1 */
              distributor_id?: number | nil;
            };
            relationships?: {
              subcategory?: {
                data?: {
                  /** @example "1" */
                  id: string;
                  type: "subcategory";
                };
              };
              brand?: {
                data?: {
                  /** @example "1" */
                  id: string;
                  type: "brand";
                };
              };
              distribution_center?: {
                data?: {
                  /** @example "1" */
                  id: string;
                  type: "distribution_center";
                };
              };
              distributor?: {
                data?: {
                  /** @example "1" */
                  id: string;
                  type: "distributor";
                };
              };
              category?: {
                data?: {
                  /** @example "1" */
                  id: string;
                  type: "category";
                };
              };
            };
          }[];
          included?: (
            | Category
            | Subcategory
            | DistributionCenter
            | Distributor
            | Brand
          )[];
          meta?: {
            page?: {
              count?: number;
              items?: number;
              page?: number;
              pages?: number;
            };
          };
          links?: {
            first?: string;
            last?: string;
            prev?: string;
            next?: string;
          };
        },
        void
      >({
        path: `/api/web/v1/margins/available_options`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Margins, Web
     * @name WebV1MarginsDelete
     * @summary delete margin(s)
     * @request DELETE:/api/web/v1/margins
     */
    webV1MarginsDelete: (
      query: {
        margin_ids: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/margins`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Margins, Web
     * @name WebV1MarginsCreate
     * @summary create margins
     * @request POST:/api/web/v1/margins
     */
    webV1MarginsCreate: (
      data: {
        data?: {
          type?: string;
          attributes?: {
            subcategory_id?: number;
            distribution_center_id?: number;
            distributor_id?: number;
            brand_id?: number;
            percentage: number;
          };
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string | nil;
            type?: "margin";
            attributes?: {
              /** @example "1-1-1-1" */
              reference_id?: string;
              /** @example 50 */
              percentage?: number | nil;
              /** @example true */
              needs_sync?: boolean | nil;
              /** @example "subcategory_default" */
              margin_level_value?: string;
              /** @example 1 */
              subcategory_id?: number | nil;
              /** @example 1 */
              distribution_center_id?: number | nil;
              /** @example 1 */
              brand_id?: number | nil;
              /** @example 1 */
              distributor_id?: number | nil;
            };
            relationships?: {
              subcategory?: {
                data?: {
                  /** @example "1" */
                  id: string;
                  type: "subcategory";
                };
              };
              brand?: {
                data?: {
                  /** @example "1" */
                  id: string;
                  type: "brand";
                };
              };
              distribution_center?: {
                data?: {
                  /** @example "1" */
                  id: string;
                  type: "distribution_center";
                };
              };
              distributor?: {
                data?: {
                  /** @example "1" */
                  id: string;
                  type: "distributor";
                };
              };
              category?: {
                data?: {
                  /** @example "1" */
                  id: string;
                  type: "category";
                };
              };
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/margins`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Margins, Web
     * @name WebV1MarginsNeedsSyncList
     * @summary check if there are margins that need to be synced
     * @request GET:/api/web/v1/margins/needs_sync
     */
    webV1MarginsNeedsSyncList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          needs_sync: boolean;
        },
        void
      >({
        path: `/api/web/v1/margins/needs_sync`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Margins, Web
     * @name WebV1MarginsQueueSyncCreate
     * @summary queue job to sync margins
     * @request POST:/api/web/v1/margins/queue_sync
     */
    webV1MarginsQueueSyncCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/web/v1/margins/queue_sync`,
        method: "POST",
        ...params,
      }),
  };
  memberships = {
    /**
     * No description
     *
     * @tags Memberships, Web
     * @name WebV1MembershipsUpdateCreate
     * @summary update memberships
     * @request POST:/api/web/v1/memberships/update
     */
    webV1MembershipsUpdateCreate: (
      data: {
        data?: {
          membership_id?: string;
          delivery_fee?: float;
          service_type?: string;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "membership" */
            type?: string;
            attributes?: {
              /** @example "some_service_type" */
              service_type?: string;
              /** @example 1 */
              building_id?: number;
              /** @example 2 */
              hubspot_location_id?: number | null;
              /** @example 99.99 */
              delivery_fee?: float | null;
              /** @example "Some Building Name" */
              building_display_name?: string;
              /** @example "Some delivery instructions" */
              delivery_instructions?: string | null;
            };
            relationships?: {
              delivery_contact?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "delivery_contact" */
                  type?: string;
                };
              };
              company?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "company" */
                  type?: string;
                };
              };
              distribution_center?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "distribution_center" */
                  type?: string;
                };
              };
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/memberships/update`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memberships, Web
     * @name WebV1MembershipsDetail
     * @summary show membership
     * @request GET:/api/web/v1/memberships/{id}
     */
    webV1MembershipsDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "membership" */
            type?: string;
            attributes?: {
              /** @example "some_service_type" */
              service_type?: string;
              /** @example 1 */
              building_id?: number;
              /** @example 2 */
              hubspot_location_id?: number | null;
              /** @example 99.99 */
              delivery_fee?: float | null;
              /** @example "Some Building Name" */
              building_display_name?: string;
              /** @example "Some delivery instructions" */
              delivery_instructions?: string | null;
            };
            relationships?: {
              delivery_contact?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "delivery_contact" */
                  type?: string;
                };
              };
              company?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "company" */
                  type?: string;
                };
              };
              distribution_center?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "distribution_center" */
                  type?: string;
                };
              };
            };
          };
        },
        void
      >({
        path: `/api/web/v1/memberships/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies, Web
     * @name WebV1MembershipsRelationshipsExternalCompaniesUsersList
     * @summary get companies users for a membership
     * @request GET:/api/web/v1/memberships/{id}/relationships/external_companies_users
     */
    webV1MembershipsRelationshipsExternalCompaniesUsersList: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: CompaniesUser[];
        },
        void
      >({
        path: `/api/web/v1/memberships/${id}/relationships/external_companies_users`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memberships, Users, Web
     * @name WebV1MembershipsRelationshipsInternalCompaniesUsersList
     * @summary show membership users
     * @request GET:/api/web/v1/memberships/{id}/relationships/internal_companies_users
     */
    webV1MembershipsRelationshipsInternalCompaniesUsersList: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "companies_user" */
            type?: string;
            attributes?: {
              /** @example "dashboard_user" */
              relationship?: string;
              /** @example "1" */
              company_id?: number | null;
              /** @example "1" */
              corporate_user_id?: string | null;
              /** @example "1" */
              owner_id?: number | null;
              /** @example "Membership" */
              owner_type?: string | null;
              /** @example 1 */
              user_id?: number;
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/memberships/${id}/relationships/internal_companies_users`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memberships, Users, Web
     * @name WebV1MembershipsRelationshipsCompaniesUsersCreate
     * @summary create membership users
     * @request POST:/api/web/v1/memberships/{id}/relationships/companies_users/{user_id}
     */
    webV1MembershipsRelationshipsCompaniesUsersCreate: (
      id: number,
      userId: number,
      data: {
        data?: {
          user_id?: number;
          owner_id?: number;
          owner_type?: string;
          relationship?: string;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "companies_user" */
            type?: string;
            attributes?: {
              /** @example "dashboard_user" */
              relationship?: string;
              /** @example "1" */
              company_id?: number | null;
              /** @example "1" */
              corporate_user_id?: string | null;
              /** @example "1" */
              owner_id?: number | null;
              /** @example "Membership" */
              owner_type?: string | null;
              /** @example 1 */
              user_id?: number;
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/memberships/${id}/relationships/companies_users/${userId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memberships, Users, Web
     * @name WebV1MembershipsRelationshipsCompaniesUsersDelete
     * @summary remove membership users
     * @request DELETE:/api/web/v1/memberships/{id}/relationships/companies_users/{user_id}
     */
    webV1MembershipsRelationshipsCompaniesUsersDelete: (
      id: number,
      userId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/memberships/${id}/relationships/companies_users/${userId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memberships, Web
     * @name WebV1MembershipsArchiveCreate
     * @summary archive membership
     * @request POST:/api/web/v1/memberships/{id}/archive
     */
    webV1MembershipsArchiveCreate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "membership" */
            type?: string;
            attributes?: {
              /** @example "some_service_type" */
              service_type?: string;
              /** @example 1 */
              building_id?: number;
              /** @example 2 */
              hubspot_location_id?: number | null;
              /** @example 99.99 */
              delivery_fee?: float | null;
              /** @example "Some Building Name" */
              building_display_name?: string;
              /** @example "Some delivery instructions" */
              delivery_instructions?: string | null;
            };
            relationships?: {
              delivery_contact?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "delivery_contact" */
                  type?: string;
                };
              };
              company?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "company" */
                  type?: string;
                };
              };
              distribution_center?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "distribution_center" */
                  type?: string;
                };
              };
            };
          };
        },
        void
      >({
        path: `/api/web/v1/memberships/${id}/archive`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memberships, Web
     * @name WebV1MembershipsUnarchiveCreate
     * @summary unarchive membership
     * @request POST:/api/web/v1/memberships/{id}/unarchive
     */
    webV1MembershipsUnarchiveCreate: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "membership" */
            type?: string;
            attributes?: {
              /** @example "some_service_type" */
              service_type?: string;
              /** @example 1 */
              building_id?: number;
              /** @example 2 */
              hubspot_location_id?: number | null;
              /** @example 99.99 */
              delivery_fee?: float | null;
              /** @example "Some Building Name" */
              building_display_name?: string;
              /** @example "Some delivery instructions" */
              delivery_instructions?: string | null;
            };
            relationships?: {
              delivery_contact?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "delivery_contact" */
                  type?: string;
                };
              };
              company?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "company" */
                  type?: string;
                };
              };
              distribution_center?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "distribution_center" */
                  type?: string;
                };
              };
            };
          };
        },
        void
      >({
        path: `/api/web/v1/memberships/${id}/unarchive`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memberships, Web
     * @name WebV1MembershipsRelationshipsArchivedAccountsList
     * @summary get archived accounts for a membership
     * @request GET:/api/web/v1/memberships/{id}/relationships/archived_accounts
     */
    webV1MembershipsRelationshipsArchivedAccountsList: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: {
            /** @example "1" */
            id?: string;
            /** @example "corporate_user" */
            type?: string;
            attributes?: {
              /** @example "pantry" */
              program?: string;
              /** @example "drop_and_go" */
              service_type?: string | null;
              /** @example 0.1 */
              order_fee_decimal?: float | null;
              /** @example 10 */
              prepayment_percent?: number | null;
              /** @example "deliveries should be made at the back" */
              delivery_instructions?: string | null;
              /** @example "2024-04-26T03:00:00.000Z" */
              speedy_delivery_cutoff?: string | null;
              /** @example "pickups should be made at the front" */
              pickup_instructions?: string | null;
              /** @example true */
              send_missed_items?: boolean | null;
              /** @example true */
              allow_chains?: boolean;
              /** @example "inventory" */
              ic_order_method?: string | null;
              /** @example true */
              overnight?: boolean;
              /** @example "budget notes" */
              budget_notes?: string | null;
              /** @example 1 */
              default_budget_id?: number | null;
              /** @example 1 */
              suite_id?: number | null;
              /** @example "nickname" */
              nickname?: string | null;
            };
            relationships?: {
              suite?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "suite" */
                  type?: string;
                };
              };
              company?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "company" */
                  type?: string;
                };
              };
              companies_users?: {
                data?: {
                  /** @example "1" */
                  id?: string;
                  /** @example "companies_user" */
                  type?: string;
                  attributes?: {
                    /** @example "dashboard_user" */
                    relationship?: string;
                    /** @example "1" */
                    company_id?: string;
                    /** @example "1" */
                    corporate_user_id?: string;
                    /** @example "1" */
                    user_id?: string;
                  };
                }[];
              };
            };
          }[];
        },
        void
      >({
        path: `/api/web/v1/memberships/${id}/relationships/archived_accounts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memberships, Web
     * @name WebV1MembershipsSiteGuideList
     * @summary get site guide for a location
     * @request GET:/api/web/v1/memberships/{membership_id}/site_guide
     */
    webV1MembershipsSiteGuideList: (
      membershipId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: SiteGuide;
        },
        void
      >({
        path: `/api/web/v1/memberships/${membershipId}/site_guide`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memberships, Web
     * @name WebV1MembershipsSiteGuideUpdate
     * @summary create or update site guide for a location
     * @request PUT:/api/web/v1/memberships/{membership_id}/site_guide
     */
    webV1MembershipsSiteGuideUpdate: (
      membershipId: number,
      data: {
        data?: PutSiteGuide;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: SiteGuide;
        },
        void
      >({
        path: `/api/web/v1/memberships/${membershipId}/site_guide`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Memberships, Web
     * @name WebV1MembershipsSiteGuideDelete
     * @summary delete site guide for a location
     * @request DELETE:/api/web/v1/memberships/{membership_id}/site_guide
     */
    webV1MembershipsSiteGuideDelete: (
      membershipId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/memberships/${membershipId}/site_guide`,
        method: "DELETE",
        ...params,
      }),
  };
  recurringOrders = {
    /**
     * No description
     *
     * @tags Recurring Orders, Web
     * @name WebV1RecurringOrdersDelete
     * @summary Soft delete a recurring order
     * @request DELETE:/api/web/v1/recurring_orders/{id}
     */
    webV1RecurringOrdersDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/web/v1/recurring_orders/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Orders, Web
     * @name WebV1RecurringOrdersArchiveUpdate
     * @summary Archive a recurring order
     * @request PUT:/api/web/v1/recurring_orders/{id}/archive
     */
    webV1RecurringOrdersArchiveUpdate: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/recurring_orders/${id}/archive`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Orders, Web
     * @name WebV1RecurringOrdersUnarchiveUpdate
     * @summary Unarchive a recurring order
     * @request PUT:/api/web/v1/recurring_orders/{id}/unarchive
     */
    webV1RecurringOrdersUnarchiveUpdate: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/web/v1/recurring_orders/${id}/unarchive`,
        method: "PUT",
        ...params,
      }),
  };
  states = {
    /**
     * No description
     *
     * @tags States, Web
     * @name WebV1StatesList
     * @summary list of supported states
     * @request GET:/api/web/v1/states
     */
    webV1StatesList: (
      query?: {
        "include[]"?: ("country" | null)[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: State;
        },
        void
      >({
        path: `/api/web/v1/states`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  validate = {
    /**
     * No description
     *
     * @tags Validations, Web
     * @name WebV1ValidateZipCodeList
     * @summary check if zip code is valid
     * @request GET:/api/web/v1/validate/zip_code
     */
    webV1ValidateZipCodeList: (
      query: {
        /** @example "12345" */
        zip_code: any;
        /** @example "US" */
        country_code: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Validation;
        },
        void
      >({
        path: `/api/web/v1/validate/zip_code`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Validations, Web
     * @name WebV1ValidateAvailableEmailList
     * @summary check if email is available
     * @request GET:/api/web/v1/validate/available_email
     */
    webV1ValidateAvailableEmailList: (
      query: {
        /** @example "bilbo.baggins@craftydelivers.com" */
        email: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Validation;
        },
        void
      >({
        path: `/api/web/v1/validate/available_email`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
